import React, { useState, useEffect, useCallback, useRef } from "react";
import SignaturePad from "./SignaturePad";
import axios from "axios";
import { ForgotPasswordModal } from "./Login";
import { 
  DOG_BREEDS, CAT_BREEDS, GROOMING_SERVICES, HOTEL_ROOMS, newPet,
  DOG_STYLES, CAT_STYLES, STYLE_IMAGES, GROOMING_TIMES_1HR, GROOMING_TIMES_2HR, HOTEL_CHECKIN_TIMES 
} from "./bookingData";

// ─── Shop Add-Ons Product Data ─────────────────────────────────────────────
const ADDON_PRODUCTS = [
  // 🐶 Dog Food & Treats
  { id: 1, category: "Dog Food & Treats", name: "Milky Biscuit", emoji: "🦴",
    variants: [{ label: "80g", price: 95 }, { label: "200g", price: 170 }] },
  { id: 2, category: "Dog Food & Treats", name: "FP Freeze Dried", emoji: "🍗",
    variants: [{ label: "Chicken Cubes 50g", price: 95 }, { label: "Egg Yolk Cubes 50g", price: 95 }] },
  { id: 3, category: "Dog Food & Treats", name: "Doggie Biscuit", emoji: "🐕",
    variants: [{ label: "80g", price: 95 }, { label: "200g", price: 170 }] },
  { id: 4, category: "Dog Food & Treats", name: "Dentastix Dog Treats", emoji: "🦷",
    variants: [{ label: "Toy Dogs · 60g", price: 135 }, { label: "Puppy · 56g", price: 120 }] },
  { id: 5, category: "Dog Food & Treats", name: "Goodest Dog", emoji: "🥩",
    variants: [
      { label: "Beef & Liver 130g", price: 55 },
      { label: "Beef w/ Veggie 130g", price: 55 },
      { label: "Chicken & Liver 130g", price: 55 },
      { label: "Beef w/ Veggies 80g", price: 45 }
    ] },
  { id: 6, category: "Dog Food & Treats", name: "Jumbone (Pedigree)", emoji: "🦴",
    variants: [{ label: "1pc", price: 120 }] },
  { id: 7, category: "Dog Food & Treats", name: "Furrpole Beef Bites", emoji: "🥩",
    variants: [{ label: "500g", price: 120 }] },

  // 🐱 Cat Food & Treats
  { id: 8, category: "Cat Food & Treats", name: "Cat Treat Temptations", emoji: "😸",
    variants: [{ label: "Chicken · 75g", price: 135 }, { label: "Salmon · 75g", price: 135 }] },
  { id: 9, category: "Cat Food & Treats", name: "Goodest Cat", emoji: "🐠",
    variants: [
      { label: "Tender Tuna 85g", price: 45 },
      { label: "Chicken 85g", price: 45 },
      { label: "Mackerel 85g", price: 45 },
      { label: "Tasty Tuna 100g", price: 120 }
    ] },
  { id: 10, category: "Cat Food & Treats", name: "Cat Treat Premium Licky", emoji: "🍬",
    variants: [{ label: "Violet · 8 sticks", price: 160 }, { label: "Pink · 8 sticks", price: 160 }, { label: "Yellow · 8 sticks", price: 160 }] },
  { id: 11, category: "Cat Food & Treats", name: "Whiskas", emoji: "🐱",
    variants: [{ label: "Ocean Fish · 80g", price: 40 }, { label: "Tuna · 80g", price: 40 }] },

  // 🧴 Pet Care Products
  { id: 12, category: "Pet Care", name: "FP Pet Cologne", emoji: "🌸",
    variants: [{ label: "100ml", price: 95 }] },
  { id: 13, category: "Pet Care", name: "FP Shampoo", emoji: "🧴",
    variants: [{ label: "1L", price: 100 }] },
  { id: 14, category: "Pet Care", name: "Toothbrush", emoji: "🪥",
    variants: [{ label: "Colored · 1pc", price: 35 }] },
  { id: 15, category: "Pet Care", name: "Pet Toothpaste", emoji: "🦷",
    variants: [{ label: "100g", price: 120 }] },
  { id: 16, category: "Pet Care", name: "Male Diaper", emoji: "🩲",
    variants: [
      { label: "XS", price: 15 },
      { label: "Small", price: 20 },
      { label: "Medium", price: 20 },
      { label: "Large", price: 25 },
      { label: "Extra Large", price: 25 }
    ] },
  { id: 17, category: "Pet Care", name: "Female Diaper", emoji: "🩲",
    variants: [
      { label: "XS", price: 15 },
      { label: "Small", price: 20 },
      { label: "Medium", price: 20 },
      { label: "Large", price: 25 },
      { label: "Extra Large", price: 25 }
    ] },
  { id: 18, category: "Pet Care", name: "LC-Vit Syrup", emoji: "💊",
    variants: [{ label: "60ml", price: 120 }] },
  { id: 19, category: "Pet Care", name: "MDC Premium Herbal Soap", emoji: "🫧",
    variants: [{ label: "135g", price: 60 }] },
  { id: 20, category: "Pet Care", name: "MDC Topical Healing Cream", emoji: "🧴",
    variants: [{ label: "10g", price: 90 }] },
  { id: 21, category: "Pet Care", name: "MDC Pure Leaf Extract Spray", emoji: "🌿",
    variants: [{ label: "100ml", price: 130 }] },
  { id: 22, category: "Pet Care", name: "Pet Toys", emoji: "🎾",
    variants: [{ label: "1pc", price: 90 }] },
  { id: 23, category: "Pet Care", name: "MDC Ointment", emoji: "🩹",
    variants: [{ label: "Regular", price: 50 }] },
];
const ADDON_CATEGORIES = [
  { id: "All", label: "All", emoji: "🐾" },
  { id: "Dog Food & Treats", label: "Dog Food", emoji: "🐶" },
  { id: "Cat Food & Treats", label: "Cat Food", emoji: "🐱" },
  { id: "Pet Care", label: "Pet Care", emoji: "🧴" },
];
const ADDON_CAT_COLORS = {
  "Dog Food & Treats": { bg: "#fef3c7", border: "#fde68a", text: "#92400e", dot: "#f59e0b" },
  "Cat Food & Treats": { bg: "#fce7f3", border: "#fbcfe8", text: "#831843", dot: "#ec4899" },
  "Pet Care":          { bg: "#d1fae5", border: "#a7f3d0", text: "#064e3b", dot: "#10b981" },
};

// Compress image before storing as base64
const compressImage = (file, maxPx = 500, quality = 0.72) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const ratio  = Math.min(maxPx / img.width, maxPx / img.height, 1);
        const canvas = document.createElement("canvas");
        canvas.width  = img.width  * ratio;
        canvas.height = img.height * ratio;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

const DogIcon = ({ size = 28, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 5.172C10 3.782 8.423 2.679 6.5 3c-2 .336-3.5 2.112-3.5 4-.085 2.053.416 3.461 1.5 4.5s1 3.5 0 4.5"/>
    <path d="m10 5.172 2 3.792c0 .01 2.36 5.036 2 6.036-1 2-4 2-5 0s-.5-4 0-5"/>
    <path d="M16.5 12s.5 2 3 3c0 3-3 5-6 4.5s-3-3.5-3-3.5"/>
    <path d="M3 12s.5-1 1-2"/><path d="M5 3.5s.5-1 2-1c.83 0 1.5.5 1.5.5"/>
  </svg>
);

const CatIcon = ({ size = 28, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5z"/>
    <path d="M8 14v.5"/><path d="M16 14v.5"/>
    <path d="M11.25 16.25h1.5L12 17l-.75-.75z"/>
  </svg>
);

const renderRoomIcon = (iconName, size = 28) => {
  if (iconName === "🐕" || iconName === "dog_small") return <DogIcon size={size} color="#6992a5" />;
  if (iconName === "🐩" || iconName === "dog_large") return <DogIcon size={size} color="#46735c" />;
  if (iconName === "🐈" || iconName === "cat_villa") return <CatIcon size={size} color="#e0a458" />;
  return <span style={{ fontSize: size }}>{iconName}</span>;
};

const applyServiceToPet = (pet, serviceCategory, services) => {
  if (!serviceCategory) return pet;
  const mappedType = (serviceCategory === "basic-grooming" || serviceCategory === "full-grooming")
    ? "grooming"
    : serviceCategory === "hotel"
    ? "hotel"
    : serviceCategory === "both"
    ? "both"
    : pet.serviceType || "grooming";

  let autoGrooming = pet.groomingService;
  if (serviceCategory === "basic-grooming" || serviceCategory === "full-grooming" || serviceCategory === "both") {
    const isBasic = serviceCategory === "basic-grooming";
    const targetName = isBasic ? "Basic Grooming" : "Full Grooming";
    if (pet.petType === "cat") {
      autoGrooming = (services?.grooming?.cat && services.grooming.cat.length > 0
        ? services.grooming.cat[0]
        : null)
        || GROOMING_SERVICES.cat[0]
        || null;
    } else {
      autoGrooming = (services?.grooming?.dog && services.grooming.dog.length > 0
        ? services.grooming.dog.find(s => s.name?.toLowerCase() === targetName.toLowerCase()) || services.grooming.dog[0]
        : null)
        || GROOMING_SERVICES.dog.find(s => s.name?.toLowerCase() === targetName.toLowerCase())
        || GROOMING_SERVICES.dog[0]
        || null;
    }
  }

  let autoHotel = pet.hotelRoom;
  if (serviceCategory === "hotel" || serviceCategory === "both") {
    if (pet.petType === "cat") {
      autoHotel = (services?.hotel && services.hotel.length > 0
        ? services.hotel.find(r => r.category === "cat" || r.id === "cat_villa" || r.name?.toLowerCase().includes("cat")) || services.hotel[0]
        : null)
        || HOTEL_ROOMS.find(r => r.id === "cat_villa" || r.name?.toLowerCase().includes("cat"))
        || HOTEL_ROOMS[0]
        || null;
    } else {
      autoHotel = (services?.hotel && services.hotel.length > 0
        ? services.hotel.find(r => r.category === "dog" || r.id === "dog_small" || r.name?.toLowerCase().includes("small")) || services.hotel[0]
        : null)
        || HOTEL_ROOMS.find(r => r.id === "dog_small" || r.name?.toLowerCase().includes("small"))
        || HOTEL_ROOMS[0]
        || null;
    }
  }

  return {
    ...pet,
    serviceType: mappedType,
    groomingService: autoGrooming,
    hotelRoom: autoHotel,
  };
};

const BookingForm = ({ user, setUser, setActiveTab, previousTab, isAdminMode = false, onSuccess, preSelectedService, clearPreSelectedService }) => {
  const [step, setStep] = useState(isAdminMode ? 1 : 0);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const targetBackTab = previousTab || (user ? (user.role === "admin" || user.role === "staff" ? "admin" : "dashboard") : "home");

  const getBackLabel = () => {
    if (targetBackTab === "dashboard") return "Back to Dashboard";
    if (targetBackTab === "services") return "Back to Services";
    if (targetBackTab === "about") return "Back to About";
    if (targetBackTab === "admin") return "Back to Admin";
    return "Back to Home";
  };

  const handleGoBackToPreviousPage = () => {
    if (window.location.hash === "#booking") {
      window.history.back();
    } else if (setActiveTab) {
      setActiveTab(targetBackTab);
    }
  };

  useEffect(() => {
    if (user && !isAdminMode && step === 1) {
      setStep(2);
    }
  }, [user, isAdminMode, step]);

  const [selectedServiceCategory, setSelectedServiceCategory] = useState(() => {
    return sessionStorage.getItem("furpect_selected_service") || null;
  });
  // eslint-disable-next-line no-unused-vars
  const [loginData, setLoginData] = useState({ emailOrPhone: "", password: "" });
  const [loginLoading, setLoginLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [bookingRegStep, setBookingRegStep] = useState("form"); // "form" | "otp" | "done"
  const [bookingOtp, setBookingOtp] = useState("");
  const [bookingOtpCooldown, setBookingOtpCooldown] = useState(0);

  // Dynamic Service State initialized with defaults so it is never empty
  const [dbServices, setDbServices] = useState({
    grooming: { 
      dog: GROOMING_SERVICES.dog, 
      cat: GROOMING_SERVICES.cat, 
      addons: GROOMING_SERVICES.addons 
    },
    hotel: HOTEL_ROOMS
  });

  // Handle pre-selected service from props or sessionStorage
  useEffect(() => {
    const rawService = preSelectedService || sessionStorage.getItem("furpect_selected_service");
    if (rawService) {
      let normalized = rawService;
      if (rawService === "boarding" || rawService === "daycare") {
        normalized = "hotel";
      } else if (rawService === "dog-grooming") {
        normalized = "basic-grooming";
      } else if (rawService === "cat-grooming") {
        normalized = "basic-grooming";
      }
      setSelectedServiceCategory(normalized);
      sessionStorage.setItem("furpect_selected_service", normalized);
      setPets(prev => prev.map(p => applyServiceToPet(p, normalized, dbServices)));
      if (clearPreSelectedService) clearPreSelectedService();
    }
  }, [preSelectedService]); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep sessionStorage and pets in sync whenever service category or services change
  useEffect(() => {
    if (selectedServiceCategory) {
      sessionStorage.setItem("furpect_selected_service", selectedServiceCategory);
      setPets(prev => prev.map(p => applyServiceToPet(p, selectedServiceCategory, dbServices)));
    }
  }, [selectedServiceCategory, dbServices]);

  // Helper: compute visual step number for display labels
  const getVisualStepNum = (internalStep) => {
    const allSteps = isAdminMode ? [1, 2, 3, 4, 5] : [0, 2, 3, 4, 5];
    const idx = allSteps.indexOf(internalStep);
    return idx >= 0 ? String(idx + 1).padStart(2, '0') : '??';
  };

  // Helper: compute add-ons grand total
  const getAddonsTotal = () => selectedAddons.reduce((sum, a) => sum + a.price * a.qty, 0);

  // Helper: update quantity of an existing addon line, or remove if qty = 0
  const setAddonQty = (productId, variantLabel, qty) => {
    setSelectedAddons(prev => {
      const idx = prev.findIndex(a => a.productId === productId && a.variantLabel === variantLabel);
      if (idx >= 0) {
        if (qty <= 0) return prev.filter((_, i) => i !== idx);
        const updated = [...prev];
        updated[idx] = { ...updated[idx], qty };
        return updated;
      }
      return prev;
    });
  };

  const addAddon = (product, variantIdx) => {
    const variant = product.variants[variantIdx];
    setSelectedAddons(prev => {
      const existing = prev.find(a => a.productId === product.id && a.variantLabel === variant.label);
      if (existing) {
        return prev.map(a =>
          a.productId === product.id && a.variantLabel === variant.label
            ? { ...a, qty: a.qty + 1 }
            : a
        );
      }
      return [...prev, {
        productId: product.id,
        productName: product.name,
        emoji: product.emoji,
        variantLabel: variant.label,
        price: variant.price,
        qty: 1,
      }];
    });
  };

  // Form State
  const [customerInfo, setCustomerInfo] = useState({
    fullName: (user && !isAdminMode) ? user.name : "",
    email: (user && !isAdminMode) ? user.email : "",
    phone: (user && !isAdminMode) ? user.phone : "",
    password: "",
    confirmPassword: "",
  });

  const [pets, setPets] = useState([newPet()]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [ownerSignature, setOwnerSignature] = useState(null);
  const signaturePadRef = useRef(null);
  const modalSignaturePadRef = useRef(null);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Payment state
  const [paymentMethod, setPaymentMethod] = useState(isAdminMode ? "Cash" : "GCash");
  const [paymentOption, setPaymentOption] = useState("10%"); // "10%", "50%", "100%", "custom"
  const [customPayAmount, setCustomPayAmount] = useState("");
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [showQrModal, setShowQrModal] = useState(false);
  const [copiedBank, setCopiedBank] = useState(null);

  // Add-Ons state (Step 4)
  // selectedAddons: [{ productId, productName, variantIdx, variantLabel, price, qty }]
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [addonCategory, setAddonCategory] = useState("All");
  // per-product selected variant index tracker
  const [addonVariantIdx, setAddonVariantIdx] = useState({});
  const [shopProducts, setShopProducts] = useState(ADDON_PRODUCTS);

  // Fetch shop add-ons from DB
  useEffect(() => {
    let ok = true;
    axios.get("/api/products")
      .then(res => {
        if (ok && res.data.success && res.data.data?.length > 0) {
          setShopProducts(res.data.data.map(p => ({ ...p, id: p.id || p._id })));
        }
      })
      .catch(() => {});
    return () => { ok = false; };
  }, []);

  // Inline Add-Pet state (for logged-in users on Step 2)
  const [showAddPetModal, setShowAddPetModal] = useState(false);
  const [addPetForm, setAddPetForm] = useState({ petName: "", petType: "dog", breed: "", isCustomBreed: false, customBreed: "", gender: "unknown", birthday: "", photoUrl: "" });
  const [addPetLoading, setAddPetLoading] = useState(false);
  const [addPetError, setAddPetError] = useState(null);


  // Fetch Services from DB
  const fetchServices = useCallback(async () => {
    try {
      const res = await axios.get("/api/services");
      if (res.data.success) {
        setDbServices(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      // Fallback to static data if API fails
      setDbServices({
        grooming: { 
          dog: GROOMING_SERVICES.dog, 
          cat: GROOMING_SERVICES.cat, 
          addons: GROOMING_SERVICES.addons 
        },
        hotel: HOTEL_ROOMS
      });
    }
  }, []);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  // Booking OTP resend cooldown timer
  useEffect(() => {
    if (bookingOtpCooldown <= 0) return;
    const t = setInterval(() => setBookingOtpCooldown(c => c - 1), 1000);
    return () => clearInterval(t);
  }, [bookingOtpCooldown]);

  // Helper to cleanly remove error keys without leaving { key: null } keys or triggering unnecessary re-renders
  const clearFieldError = (...keys) => {
    setFormErrors(prev => {
      let changed = false;
      const copy = { ...prev };
      for (const k of keys) {
        if (k in copy) {
          delete copy[k];
          changed = true;
        }
      }
      return changed ? copy : prev;
    });
  };

  // Auto-scroll to first validation error
  useEffect(() => {
    const errorKeys = Object.keys(formErrors).filter(k => !!formErrors[k]);
    if (errorKeys.length === 0) return;
    const firstKey = errorKeys.find(k => k !== 'submit' && k !== 'terms');
    if (!firstKey) return;

    // Never auto-scroll if the user is currently typing/focused in an input inside that field
    const activeEl = document.activeElement;
    const targetEl = document.getElementById(`field-${firstKey}`);
    if (targetEl && activeEl && targetEl.contains(activeEl)) return;

    const timer = setTimeout(() => {
      const el = document.getElementById(`field-${firstKey}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 50);
    return () => clearTimeout(timer);
  }, [formErrors]);

  // Availability Cache
  const [availability, setAvailability] = useState({});

  // Handlers
  const handleCustomerChange = (e) => {
    let val = e.target.value;
    if (e.target.name === "phone") {
      val = val.replace(/\D/g, "").slice(0, 11);
    }
    setCustomerInfo({ ...customerInfo, [e.target.name]: val });
  };

  const handlePetChange = (index, fieldOrObj, value) => {
    setPets((prev) => {
      const updatedPets = prev.map((p, i) => (i === index ? { ...p } : p));
      if (typeof fieldOrObj === "object" && fieldOrObj !== null) {
        updatedPets[index] = { ...updatedPets[index], ...fieldOrObj };
      } else {
        updatedPets[index][fieldOrObj] = value;
        if (fieldOrObj === "petType") {
          updatedPets[index].breed = "";
          if (selectedServiceCategory) {
            updatedPets[index] = applyServiceToPet(updatedPets[index], selectedServiceCategory, dbServices);
            updatedPets[index].groomingSize = null;
          }
        }
      }
      return updatedPets;
    });
  };

  const addPet = () => {
    let pet = newPet();
    if (selectedServiceCategory) {
      pet = applyServiceToPet(pet, selectedServiceCategory, dbServices);
    }
    setPets([...pets, pet]);
  };
  const removePet = (index) => setPets(pets.filter((_, i) => i !== index));

  const validateStep = (currentStep) => {
    const newErrors = {};
    if (currentStep === 1) {
      if (!customerInfo.fullName.trim()) newErrors.fullName = "Full Name is required";
      if (!customerInfo.email.trim() || !/^\S+@\S+\.\S+$/.test(customerInfo.email)) newErrors.email = "Valid Email is required";
      const cleanPhone = customerInfo.phone.trim().replace(/\D/g, "");
      if (!cleanPhone) {
        newErrors.phone = "Contact Number is required";
      } else if (!cleanPhone.startsWith("09")) {
        newErrors.phone = "Contact Number must start with 09 (e.g. 09123456789)";
      } else if (cleanPhone.length !== 11) {
        newErrors.phone = "Contact Number must be exactly 11 digits";
      }
      if (!user && !isAdminMode) {
        if (!customerInfo.password) newErrors.password = "Password is required";
        else if (customerInfo.password.length < 6) newErrors.password = "Min 6 characters";
        if (customerInfo.password !== customerInfo.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
      }
    }
    if (currentStep === 2) {
      pets.forEach((p, i) => {
        if (!p.petName.trim()) newErrors[`petName_${i}`] = "Name required";
        if (!p.petType) newErrors[`petType_${i}`] = "Type required";
        if (!p.isCustomBreed && !p.breed) newErrors[`breed_${i}`] = "Breed required";
        if (p.isCustomBreed && !p.customBreed?.trim()) newErrors[`customBreed_${i}`] = "Please specify";
        if (!p.birthday) newErrors[`birthday_${i}`] = "Birthdate required";
      });
    }
    if (currentStep === 3) {
      pets.forEach((p, i) => {
        if (!p.serviceType) newErrors[`serviceType_${i}`] = "Select a service";
        if (p.serviceType === "grooming" || p.serviceType === "both") {
          if (!p.groomingService) newErrors[`groomingService_${i}`] = "Package required";
          if (p.groomingService?.sizes?.length > 0 && !p.groomingSize) newErrors[`groomingSize_${i}`] = "Pet size required";
          if (!p.groomingDate) {
            newErrors[`groomingDate_${i}`] = "Date required";
          } else {
            const gDay = new Date(p.groomingDate + "T00:00:00").getDay();
            if (gDay === 1) newErrors[`groomingDate_${i}`] = "We are closed on Mondays. Please choose another date.";
          }
          if (!p.groomingTime) newErrors[`groomingTime_${i}`] = "Time required";
        }
        if (p.serviceType === "hotel" || p.serviceType === "both") {
          if (!p.hotelRoom) newErrors[`hotelRoom_${i}`] = "Room required";
          if (!p.checkInDate) {
            newErrors[`checkInDate_${i}`] = "Check-in required";
          } else {
            const ciDay = new Date(p.checkInDate + "T00:00:00").getDay();
            if (ciDay === 1) newErrors[`checkInDate_${i}`] = "Store is closed on Mondays. Please choose another check-in date. (Check-out on Monday is allowed for hotel stays)";
          }
          if (!p.checkInTime) newErrors[`checkInTime_${i}`] = "Time required";
          if (!p.stayDays || Number(p.stayDays) < 1) {
            newErrors[`stayDays_${i}`] = "Please enter at least 1 day of stay";
          }
        }
        
        // Health & Behavior — only the vaccination photo is required
        if (p.serviceType) {
          if (!p.vaccinationPhotoUrl) newErrors[`vaccinationPhotoUrl_${i}`] = "Vaccination record required (unvaccinated pets cannot be accepted)";
          if (!p.healthStatus) newErrors[`healthStatus_${i}`] = "Please select your pet's health status";
          if (p.healthStatus === "not_healthy") {
            if (!p.medicalConditions?.trim()) newErrors[`medicalConditions_${i}`] = "Please describe your pet's medical condition";
            if (!p.medication?.trim()) newErrors[`medication_${i}`] = "Please enter the medication your pet is taking";
          }
        }
      });
    }
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateStep(step)) return;

    if (step === 2 && user && !isAdminMode) {
      setLoading(true);
      try {
        let updatedPetsList = [...pets];
        if (selectedServiceCategory) {
          updatedPetsList = updatedPetsList.map(p => applyServiceToPet(p, selectedServiceCategory, dbServices));
        }
        for (let i = 0; i < updatedPetsList.length; i++) {
          let p = updatedPetsList[i];
          const petData = {
            petName: p.petName,
            petType: p.petType,
            breed: p.breed,
            isCustomBreed: p.isCustomBreed,
            customBreed: p.customBreed,
            gender: p.gender,
            birthday: p.birthday || undefined, // prevent empty string cast error
            photoUrl: p.photoUrl,
            behaviorNotes: p.behaviorNotes,
            vetCard: p.vetCard
          };

          if (!p._id) {
            const res = await axios.post("/api/auth/me/pets", petData, { 
              headers: { Authorization: `Bearer ${user.token}` } 
            });
            if (res.data.success) {
              const newPetsArray = res.data.data;
              const createdPet = newPetsArray[newPetsArray.length - 1];
              updatedPetsList[i] = { ...p, _id: createdPet._id };
            }
          } else {
            await axios.put(`/api/auth/me/pets/${p._id}`, petData, { 
              headers: { Authorization: `Bearer ${user.token}` } 
            });
          }
        }

        const userRes = await axios.get("/api/auth/me", { headers: { Authorization: `Bearer ${user.token}` } });
        if (userRes.data.success) {
          const freshUser = { ...user, pets: userRes.data.pets };
          setUser(freshUser);
          localStorage.setItem("user", JSON.stringify(freshUser));
        }

        setPets(updatedPetsList);
      } catch (err) {
        console.error("Error saving pets:", err);
        let errorDetails = err.response?.data?.message || err.response?.data || err.message || "Unknown error";
        if (typeof errorDetails === "object") errorDetails = JSON.stringify(errorDetails);
        setFormErrors({ submit: `Error: ${errorDetails}` });
        setLoading(false);
        return;
      }
      setLoading(false);
    }

    setStep(step + 1);
  };

  // Login handler for Step 1 login mode
  const handleBookingLogin = async () => {
    if (!loginData.emailOrPhone || !loginData.password) {
      setFormErrors({ login: "Please fill in all fields" });
      return;
    }
    setLoginLoading(true);
    setFormErrors({});
    try {
      const response = await axios.post("/api/auth/login", {
        emailOrPhone: loginData.emailOrPhone,
        password: loginData.password,
      });
      if (response.data.success !== false) {
        // Save user and auto-fill customer info
        localStorage.setItem("user", JSON.stringify(response.data));
        setUser(response.data);
        setCustomerInfo({
          fullName: response.data.name || "",
          email: response.data.email || "",
          phone: response.data.phone || "",
          password: "",
          confirmPassword: "",
        });
        if (selectedServiceCategory) {
          setPets(prev => prev.map(p => applyServiceToPet(p, selectedServiceCategory, dbServices)));
        }
        // Advance to pet profiles
        setShowAuthModal(false);
        setStep(2);
      }
    } catch (err) {
      setFormErrors({ login: err.response?.data?.message || "Login failed. Check your credentials." });
    } finally {
      setLoginLoading(false);
    }
  };

  // Booking register: step 1 - send OTP to email
  const handleRegister = async () => {
    if (!validateStep(1)) return;
    setRegisterLoading(true);
    setFormErrors({});
    try {
      await axios.post("/api/auth/send-email-otp", { email: customerInfo.email });
      setBookingOtp("");
      setBookingOtpCooldown(60);
      setBookingRegStep("otp");
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to send verification code";
      if (msg.toLowerCase().includes("already exists")) {
        setFormErrors({ register: "This email already has an account. Please sign in instead." });
      } else {
        setFormErrors({ register: msg });
      }
    } finally {
      setRegisterLoading(false);
    }
  };

  // Booking register: step 2 - verify OTP then create account
  const handleVerifyBookingOtp = async () => {
    if (!bookingOtp.trim() || bookingOtp.length < 6) {
      setFormErrors({ register: "Please enter the 6-digit code" });
      return;
    }
    setRegisterLoading(true);
    setFormErrors({});
    try {
      // Verify OTP
      await axios.post("/api/auth/verify-email-otp", { email: customerInfo.email, otp: bookingOtp });

      // Create account (email is now pre-verified)
      const response = await axios.post("/api/auth/register", {
        name: customerInfo.fullName,
        email: customerInfo.email,
        phone: customerInfo.phone,
        password: customerInfo.password,
      });

      if (response.data.success && response.data.token) {
        const userData = {
          _id: response.data._id,
          name: response.data.name,
          email: response.data.email,
          phone: response.data.phone,
          token: response.data.token,
          role: response.data.role,
          pets: response.data.pets || [],
        };
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
        if (selectedServiceCategory) {
          setPets(prev => prev.map(p => applyServiceToPet(p, selectedServiceCategory, dbServices)));
        }
        setBookingRegStep("done");
        setRegisterSuccess(true);
      } else {
        setFormErrors({ register: "Account creation failed. Please try again." });
        setBookingRegStep("form");
      }
    } catch (err) {
      setFormErrors({ register: err.response?.data?.message || "Verification failed. Please try again." });
    } finally {
      setRegisterLoading(false);
    }
  };

  // Resend OTP inside booking register modal
  const handleResendBookingOtp = async () => {
    if (bookingOtpCooldown > 0) return;
    setRegisterLoading(true);
    setFormErrors({});
    try {
      await axios.post("/api/auth/send-email-otp", { email: customerInfo.email });
      setBookingOtp("");
      setBookingOtpCooldown(60);
    } catch (err) {
      setFormErrors({ register: err.response?.data?.message || "Failed to resend code" });
    } finally {
      setRegisterLoading(false);
    }
  };

  const fetchAvailability = async (petIndex, serviceType, date, roomType = null) => {
    if (!date || !serviceType) return;
    try {
      const res = await axios.get("/api/appointments/availability", {
        params: { serviceType, date, roomType }
      });
      const key = `${serviceType}-${date}-${roomType || ""}`;
      setAvailability(prev => ({ ...prev, [key]: res.data }));
    } catch (err) {
      console.error("Availability fetch error", err);
    }
  };

  const handleSubmit = async () => {
    // Compute total & min downpayment for validation
    const serviceTotal = pets.reduce((acc, p) => {
      let price = 0;
      if (p.serviceType === "grooming" || p.serviceType === "both") price += (p.groomingSize?.price || p.groomingService?.price || 0);
      if (p.serviceType === "hotel" || p.serviceType === "both") {
        const days = Number(p.stayDays) || 1;
        price += (p.hotelRoom?.price || 0) * days;
      }
      return acc + price;
    }, 0);
    const addonsTotal = getAddonsTotal();
    const totalAmt = serviceTotal + addonsTotal;
    const minDown = Math.ceil(totalAmt * 0.10);
    
    let actualPayAmount = minDown;
    let actualPaymentType = "downpayment";

    if (paymentOption === "50%") {
      actualPayAmount = Math.ceil(totalAmt * 0.50);
      actualPaymentType = "custom";
    } else if (paymentOption === "100%") {
      actualPayAmount = totalAmt;
      actualPaymentType = "full";
    } else if (paymentOption === "custom") {
      const parsed = Number(customPayAmount);
      if (!customPayAmount || isNaN(parsed) || parsed < minDown) {
        setFormErrors({ payment: `Custom payment amount must be at least 10% (₱${minDown.toLocaleString()})` });
        document.getElementById("field-payment")?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      actualPayAmount = Math.min(parsed, totalAmt);
      actualPaymentType = actualPayAmount >= totalAmt ? "full" : "custom";
    }

    // Payment validation
    if (paymentMethod !== "Cash") {
      if (!paymentScreenshot) {
        setFormErrors({ payment: "Please upload your payment screenshot" });
        document.getElementById("field-payment")?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      if (!referenceNumber.trim()) {
        setFormErrors({ payment: "Please enter your reference number" });
        const refInput = document.getElementById("reference-number-input");
        if (refInput) {
          refInput.scrollIntoView({ behavior: "smooth", block: "center" });
          refInput.focus();
        } else {
          document.getElementById("field-payment")?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
    }
    if (!acceptedTerms) {
      setFormErrors({ terms: "Please accept terms" });
      document.getElementById("field-signature")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    if (!ownerSignature) {
      setFormErrors({ signature: "Please sign the Terms & Conditions before submitting" });
      document.getElementById("field-signature")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    if (!validateStep(5)) return;

    setLoading(true);
    setFormErrors({});

    try {
      const payload = {
        ownerName: customerInfo.fullName,
        ownerEmail: customerInfo.email,
        ownerPhone: customerInfo.phone,
        ownerSignature: ownerSignature || undefined,
        password: (!user && !isAdminMode) ? (customerInfo.password || undefined) : undefined,
        isAdminWalkin: isAdminMode ? true : undefined,
        paymentMethod: paymentMethod,
        paymentType: actualPaymentType,
        downpaymentAmount: actualPayAmount,
        paymentScreenshot: paymentScreenshot || undefined,
        referenceNumber: paymentMethod === "Cash" ? undefined : (referenceNumber.trim() || undefined),
        addOns: selectedAddons.length > 0 ? selectedAddons.map(a => ({
          name: a.productName,
          variant: a.variantLabel,
          qty: a.qty,
          unitPrice: a.price,
          subtotal: a.price * a.qty,
        })) : undefined,
        pets: pets.map(p => ({
          petName: p.petName,
          petType: p.petType,
          breed: p.isCustomBreed ? p.customBreed : p.breed,
          gender: p.gender,
          birthday: p.birthday || null,
          photoUrl: p.photoUrl,
          behaviorNotes: p.behaviorNotes,
          serviceType: p.serviceType,
          grooming: p.serviceType === "grooming" || p.serviceType === "both" ? {
            service: p.groomingService?.name || p.groomingService?._id || p.groomingService?.id,
            size: p.groomingSize?.label,
            haircutStyle: p.haircutStyle,
            haircutInstructions: p.haircutInstructions,
            date: p.groomingDate,
            time: p.groomingTime,
            price: (p.groomingSize?.price || p.groomingService?.price || 0),
            addOns: p.groomingAddons
          } : undefined,
          hotel: p.serviceType === "hotel" || p.serviceType === "both" ? {
            roomType: p.hotelRoom?.name || p.hotelRoom?._id || p.hotelRoom?.id,
            checkInDate: p.checkInDate,
            checkInTime: p.checkInTime,
            stayDays: Number(p.stayDays) || 1,
            checkOutDate: (() => {
              if (!p.checkInDate) return undefined;
              const co = new Date(p.checkInDate + "T00:00:00");
              co.setDate(co.getDate() + (Number(p.stayDays) || 1));
              return co.toISOString().split("T")[0];
            })(),
            checkOutTime: p.checkInTime || undefined,
            feedingInstructions: p.feedingInstructions,
            pricePerNight: p.hotelRoom?.price,
            totalPrice: (p.hotelRoom?.price || 0) * (Number(p.stayDays) || 1)
          } : undefined,
          health: {
            isVaccinated: p.isVaccinated === "yes",
            lastVaccinationDate: p.lastVaccinationDate,
            vaccinationPhotoUrl: p.vaccinationPhotoUrl,
            healthStatus: p.healthStatus,
            medicalConditions: p.healthStatus === "not_healthy" ? p.medicalConditions : "",
            medication: p.healthStatus === "not_healthy" ? p.medication : ""
          }
        }))
      };

      const headers = {};
      if (user?.token) {
        headers.Authorization = `Bearer ${user.token}`;
      }

      const res = await axios.post("/api/appointments", payload, { headers });
      
      if (res.data.user && !isAdminMode) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        setUser(res.data.user);
      }
      
      if (isAdminMode && onSuccess) {
        onSuccess();
        return;
      }
      
      sessionStorage.removeItem("furpect_selected_service");
      setSuccess(true);
      setLoading(false);
    } catch (err) {
      setFormErrors({ submit: err.response?.data?.message || err.message || "Failed to submit booking" });
      setLoading(false);
    }
  };

  // Render Helpers
  const renderStepIndicator = () => {
    const allSteps = isAdminMode ? [1, 2, 3, 4, 5] : [0, 2, 3, 4, 5];
    const currentIdx = allSteps.indexOf(step);
    const total = allSteps.length;
    const stepLabels = isAdminMode
      ? ["Customer", "Pet Info", "Schedule", "Add-Ons", "Review"]
      : ["Service", "Pet Info", "Schedule", "Add-Ons", "Review"];

    return (
      <div className="flex justify-between mb-12 relative">
        <div className="absolute top-1/2 left-0 w-full h-1 bg-purple-100 -translate-y-1/2 z-0"></div>
        <div 
          className="absolute top-1/2 left-0 h-1 bg-gradient-to-r from-purple-500 to-pink-500 -translate-y-1/2 z-0 transition-all duration-500"
          style={{ width: `${(Math.max(0, currentIdx) / (total - 1)) * 100}%` }}
        ></div>
        {allSteps.map((s, i) => (
          <div key={s} className="flex flex-col items-center gap-1.5 relative z-10">
            <div
              className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-xs sm:text-sm transition-all duration-500 ${
                currentIdx >= i ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg scale-110" : "bg-white text-purple-300 border-2 border-purple-100"
              }`}
            >
              {i + 1}
            </div>
            <span className={`text-[9px] sm:text-[10px] font-bold block text-center transition-colors ${
              currentIdx >= i ? "text-purple-600" : "text-gray-400"
            }`}>{stepLabels[i]}</span>
          </div>
        ))}
      </div>
    );
  };

  if (success) {
    return (
      <div className="max-w-3xl mx-auto mt-10 sm:mt-20 p-6 sm:p-12 bg-white/80 backdrop-blur-xl rounded-[2rem] sm:rounded-[3rem] shadow-2xl border border-white text-center">
        <div className="w-20 h-20 sm:w-24 sm:h-24 bg-emerald-100 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6 text-4xl sm:text-5xl">🐾</div>
        <h2 className="text-2xl sm:text-4xl font-black text-gray-800 mb-4">{isAdminMode ? "Walk-In Appointment Booked!" : "Booking Successful!"}</h2>
        <p className="text-sm sm:text-xl text-gray-600 mb-8 sm:mb-10">
          {isAdminMode ? "The walk-in appointment has been successfully scheduled and recorded." : "Your appointment has been scheduled and your account is ready. We can't wait to meet your furry friend!"}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => {
              if (onSuccess) onSuccess();
              if (setActiveTab) setActiveTab(isAdminMode ? "admin" : "dashboard");
            }}
            className="px-8 sm:px-10 py-3.5 sm:py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-xl hover:scale-105 transition-all text-sm"
          >
            {isAdminMode ? "Return to Admin Panel 📋" : "View My Dashboard 📋"}
          </button>
          {!isAdminMode && (
            <button
              onClick={() => setActiveTab("home")}
              className="px-8 sm:px-10 py-3.5 sm:py-4 bg-white border-2 border-purple-100 text-purple-600 font-bold rounded-2xl hover:bg-purple-50 transition-all text-sm"
            >
              Return Home
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto my-4 sm:my-12 p-4 sm:p-8 md:p-12 bg-white/70 backdrop-blur-2xl rounded-[2rem] sm:rounded-[3rem] shadow-2xl border border-white/50 relative">
      <div className="flex items-center justify-start mb-6">
        <button
          type="button"
          onClick={handleGoBackToPreviousPage}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-bold text-purple-700 bg-purple-50 hover:bg-purple-100 hover:text-purple-900 rounded-2xl transition-all border border-purple-200/80 shadow-sm hover:shadow-md cursor-pointer group"
        >
          <svg className="w-4 h-4 transition-transform group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span>{getBackLabel()}</span>
        </button>
      </div>

      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-black bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent mb-4">
          Book an Appointment
        </h2>
        <p className="text-gray-500 text-lg">Your pet's premium experience starts here 🐾</p>
      </div>

      {renderStepIndicator()}

      {formErrors.submit && (
        <div className="mb-8 p-4 bg-red-50 border-2 border-red-100 text-red-600 rounded-2xl font-bold flex items-center">
          <span className="mr-3">⚠️</span> {formErrors.submit}
        </div>
      )}

      {/* STEP 0: CHOOSE SERVICE */}
      {step === 0 && (
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
          <div className="text-center space-y-2">
            <h3 className="text-2xl font-bold text-gray-800 flex items-center justify-center gap-3">
              <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center text-sm">{getVisualStepNum(0)}</span>
              What service would you like?
            </h3>
            <p className="text-gray-500">Select the service you'd like to avail for your fur baby</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              { id: "basic-grooming", icon: "🐾", title: "Basic Grooming", desc: "Bath & Blow Dry, Nail Trimming, Ear Cleaning, Basic Brush Out", gradient: "from-purple-500 to-violet-600", border: "border-purple-300", accent: "#7C3AED" },
              { id: "full-grooming", icon: "✨", title: "Full Grooming", desc: "Everything in Basic + Haircut & Styling, Cologne Spritz", gradient: "from-pink-500 to-rose-600", border: "border-pink-300", accent: "#EC4899" },
              { id: "hotel", icon: "🏨", title: "Boarding / Daycare", desc: "Overnight stays in cozy rooms or fun-filled daycare with 24/7 supervision", gradient: "from-teal-500 to-emerald-600", border: "border-teal-300", accent: "#14B8A6" },
              { id: "both", icon: "🐾🏨", title: "Grooming + Boarding", desc: "Combine any grooming package with boarding for the complete pet care experience", gradient: "from-orange-500 to-amber-600", border: "border-orange-300", accent: "#F97316" },
            ].map((option) => (
              <button
                key={option.id}
                onClick={() => {
                  setSelectedServiceCategory(option.id);
                  setPets(prev => prev.map(p => applyServiceToPet(p, option.id, dbServices)));
                  if (user && !isAdminMode) {
                    setStep(2);
                  } else if (!isAdminMode) {
                    setShowAuthModal(true);
                  } else {
                    setStep(1);
                  }
                }}
                className={`group relative p-6 sm:p-8 rounded-[2rem] border-2 text-left transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl overflow-hidden ${
                  selectedServiceCategory === option.id
                    ? `${option.border} shadow-xl ring-2 ring-purple-300 bg-white`
                    : `border-purple-50 bg-white/60 hover:bg-white`
                }`}
              >
                {/* Decorative circle */}
                <div className={`absolute top-0 right-0 w-28 h-28 rounded-full bg-gradient-to-br ${option.gradient} opacity-[0.07] -translate-y-1/2 translate-x-1/2 group-hover:scale-[2] transition-transform duration-700`}></div>
                <div className="relative z-10">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${option.gradient} flex items-center justify-center text-2xl mb-4 shadow-lg group-hover:scale-110 group-hover:shadow-xl transition-all duration-300`}>
                    {option.icon}
                  </div>
                  <h4 className="text-lg font-black text-gray-800 mb-2 group-hover:text-gray-900">{option.title}</h4>
                  <p className="text-sm text-gray-500 leading-relaxed">{option.desc}</p>
                  <div className="mt-5 flex items-center gap-2 text-sm font-bold opacity-60 group-hover:opacity-100 transition-opacity duration-300" style={{ color: option.accent }}>
                    Select & Continue
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {!isAdminMode && (
            <div className="flex justify-center pt-4">
              <button
                type="button"
                onClick={handleGoBackToPreviousPage}
                className="px-6 py-2.5 text-gray-500 hover:text-purple-700 text-sm font-semibold transition-colors flex items-center gap-2 rounded-xl hover:bg-purple-50"
              >
                ← Return to {targetBackTab === 'dashboard' ? 'Dashboard' : targetBackTab === 'services' ? 'Services' : targetBackTab === 'about' ? 'About' : 'Home'}
              </button>
            </div>
          )}
        </div>
      )}

      {/* STEP 1: ADMIN WALK-IN CUSTOMER INFO (admin mode only) */}
      {step === 1 && isAdminMode && (
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
          <h3 className="text-2xl font-bold text-gray-800 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mr-3 text-sm">{getVisualStepNum(1)}</span>
            Customer Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div id="field-fullName" className="space-y-1">
              <label className="text-sm font-bold text-gray-700 ml-1">Full Name</label>
              <input type="text" name="fullName" value={customerInfo.fullName} onChange={handleCustomerChange}
                className={`w-full p-4 bg-white/50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.fullName ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                placeholder="John Doe" />
              {formErrors.fullName && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors.fullName}</p>}
            </div>
            <div id="field-email" className="space-y-1">
              <label className="text-sm font-bold text-gray-700 ml-1">Email Address</label>
              <input type="email" name="email" value={customerInfo.email} onChange={handleCustomerChange}
                className={`w-full p-4 bg-white/50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.email ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                placeholder="john@example.com" />
              {formErrors.email && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors.email}</p>}
            </div>
          </div>
          <div id="field-phone" className="space-y-1">
            <label className="text-sm font-bold text-gray-700 ml-1">Contact Number</label>
            <input type="tel" name="phone" value={customerInfo.phone} onChange={handleCustomerChange} maxLength={11}
              className={`w-full p-4 bg-white/50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.phone ? "border-red-400 bg-red-50" : "border-purple-100"}`}
              placeholder="09123456789" />
            {formErrors.phone && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors.phone}</p>}
          </div>
          <div className="flex justify-end">
            <button onClick={handleNext} className="px-12 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-xl hover:scale-105 transition-all">
              Next: Pet Profiles →
            </button>
          </div>
        </div>
      )}

      {/* LOGIN MODAL (non-admin, non-logged-in) */}
      {showAuthModal && !isAdminMode && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowAuthModal(false)} />
          <div className="relative z-10 w-full max-w-xl bg-white rounded-[2rem] shadow-2xl flex flex-col animate-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="px-10 pt-8 pb-6 bg-gradient-to-r from-purple-600 to-pink-600 rounded-t-[2rem]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <span className="text-3xl">🐾</span>
                  <div>
                    <h3 className="font-black text-white text-xl">Welcome Back!</h3>
                    <p className="text-purple-200 text-sm">Sign in to continue booking</p>
                  </div>
                </div>
                <button onClick={() => setShowAuthModal(false)} className="text-white/70 hover:text-white text-3xl font-bold transition-colors leading-none">&times;</button>
              </div>
            </div>
            {/* Body */}
            <div className="px-10 py-8 space-y-6">
              {formErrors.login && (
                <div className="p-4 bg-red-50 border-2 border-red-100 text-red-600 rounded-2xl font-bold flex items-center gap-2">
                  <span>⚠️</span> {formErrors.login}
                </div>
              )}
              <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700 ml-1">Email or Phone Number</label>
                <input type="text" value={loginData.emailOrPhone}
                  onChange={(e) => { setLoginData({ ...loginData, emailOrPhone: e.target.value }); setFormErrors({}); }}
                  className={`w-full p-4 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.login ? "border-red-200" : "border-purple-100"}`}
                  placeholder="john@example.com or 0912 345 6789"
                  onKeyDown={(e) => e.key === "Enter" && loginData.emailOrPhone && loginData.password && handleBookingLogin()}
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700 ml-1">Password</label>
                <div className="relative">
                  <input type={showLoginPassword ? "text" : "password"} value={loginData.password}
                    onChange={(e) => { setLoginData({ ...loginData, password: e.target.value }); setFormErrors({}); }}
                    className={`w-full p-4 pr-14 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all [&::-ms-reveal]:hidden ${formErrors.login ? "border-red-200" : "border-purple-100"}`}
                    placeholder="Enter your password"
                    onKeyDown={(e) => e.key === "Enter" && loginData.emailOrPhone && loginData.password && handleBookingLogin()}
                  />
                  <button type="button" onClick={() => setShowLoginPassword(v => !v)} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 hover:bg-purple-100 rounded-xl transition-all">
                    {showLoginPassword ? (
                      <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" /></svg>
                    ) : (
                      <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                    )}
                  </button>
                </div>
                <div className="flex justify-end pt-1">
                  <button
                    type="button"
                    onClick={() => setShowForgotModal(true)}
                    className="text-xs font-bold text-purple-600 hover:text-pink-600 transition-colors underline underline-offset-2"
                  >
                    Forgot Password?
                  </button>
                </div>
              </div>
              <button onClick={handleBookingLogin} disabled={loginLoading || !loginData.emailOrPhone || !loginData.password}
                className={`w-full py-5 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg rounded-2xl shadow-xl transition-all ${loginLoading ? "opacity-50 cursor-wait" : "hover:scale-[1.02] hover:shadow-purple-400/40"} disabled:opacity-50 disabled:cursor-not-allowed`}>
                {loginLoading ? "Signing In..." : "Sign In & Continue"}
              </button>
              <p className="text-center text-gray-500">
                Don't have an account?{" "}
                <button type="button" onClick={() => { setShowAuthModal(false); setShowRegisterModal(true); setFormErrors({}); }}
                  className="font-bold text-purple-600 hover:text-pink-600 transition-colors underline underline-offset-2">Register here</button>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* FORGOT PASSWORD MODAL */}
      {showForgotModal && (
        <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
      )}

      {/* REGISTER MODAL (separate, bigger) */}
      {showRegisterModal && !isAdminMode && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowRegisterModal(false)} />
          <div className="relative z-10 w-full max-w-2xl bg-white rounded-[2rem] shadow-2xl flex flex-col animate-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="px-10 pt-8 pb-6 bg-gradient-to-r from-fuchsia-600 to-purple-600 rounded-t-[2rem]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <span className="text-3xl">✨</span>
                  <div>
                    <h3 className="font-black text-white text-xl">Create Your Account</h3>
                    <p className="text-purple-200 text-sm">Register to start booking for your fur baby</p>
                  </div>
                </div>
                <button onClick={() => setShowRegisterModal(false)} className="text-white/70 hover:text-white text-3xl font-bold transition-colors leading-none">&times;</button>
              </div>
            </div>
            {/* Body */}
            <div className="px-10 py-8 space-y-6">
              {/* ── Success state ── */}
              {registerSuccess ? (
                <div className="text-center space-y-6 py-4 animate-in zoom-in duration-300">
                  <div className="w-24 h-24 bg-gradient-to-br from-emerald-100 to-green-200 text-emerald-600 rounded-full flex items-center justify-center text-5xl mx-auto shadow-lg ring-4 ring-emerald-50">
                    🎉
                  </div>
                  <div>
                    <h3 className="text-3xl font-black text-gray-800 mb-2">Account Created!</h3>
                    <p className="text-gray-500 text-base">
                      Welcome to the FurpectTails family 🐾 What would you like to do next?
                    </p>
                  </div>

                  <div className="space-y-3 max-w-md mx-auto w-full pt-2">
                    {/* Primary: Continue Booking */}
                    <button
                      onClick={() => {
                        setShowRegisterModal(false);
                        setRegisterSuccess(false);
                        setBookingRegStep("form");
                        if (selectedServiceCategory) {
                          setPets(prev => prev.map(p => applyServiceToPet(p, selectedServiceCategory, dbServices)));
                        }
                        setStep(2);
                      }}
                      className="w-full py-4 px-6 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold text-lg rounded-2xl shadow-xl hover:scale-[1.02] hover:shadow-purple-400/40 transition-all flex items-center justify-center gap-3 cursor-pointer"
                    >
                      <span>📅</span> Continue Booking
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>

                    {/* Secondary: Go to Dashboard */}
                    <button
                      onClick={() => {
                        setShowRegisterModal(false);
                        setRegisterSuccess(false);
                        setBookingRegStep("form");
                        if (setActiveTab) setActiveTab("dashboard");
                      }}
                      className="w-full py-4 px-6 bg-white border-2 border-purple-100 hover:border-purple-300 text-purple-700 hover:bg-purple-50 font-bold text-base rounded-2xl transition-all flex items-center justify-center gap-2 cursor-pointer"
                    >
                      <span>🏠</span> Go to My Dashboard
                    </button>
                  </div>
                </div>

              /* ── OTP verification state ── */
              ) : bookingRegStep === "otp" ? (
                <div className="space-y-5 animate-in fade-in duration-300">
                  <div className="text-center space-y-1">
                    <div className="text-4xl mb-2">✉️</div>
                    <h4 className="font-black text-gray-800 text-lg">Check your email</h4>
                    <p className="text-gray-500 text-sm">
                      We sent a 6-digit code to <span className="font-bold text-purple-600">{customerInfo.email}</span>
                    </p>
                    <p className="text-xs text-gray-400">Check your inbox and spam/promotions folder</p>
                  </div>

                  {formErrors.register && (
                    <div className="p-4 bg-red-50 border-2 border-red-100 text-red-600 rounded-2xl font-bold flex items-center gap-2">
                      <span>⚠️</span> {formErrors.register}
                    </div>
                  )}

                  <div>
                    <label className="text-sm font-bold text-gray-700 ml-1 block mb-2 text-center uppercase tracking-wider">Enter Verification Code</label>
                    <input
                      type="text"
                      maxLength="6"
                      value={bookingOtp}
                      onChange={(e) => setBookingOtp(e.target.value.replace(/\D/g, ""))}
                      onKeyDown={(e) => e.key === "Enter" && bookingOtp.length === 6 && handleVerifyBookingOtp()}
                      className="w-full text-center text-3xl font-black tracking-[0.5em] p-4 bg-gray-50 border-2 border-gray-100 rounded-2xl focus:border-purple-400 focus:bg-white outline-none transition-all"
                      placeholder="------"
                      autoFocus
                    />
                  </div>

                  <button
                    onClick={handleVerifyBookingOtp}
                    disabled={registerLoading || bookingOtp.length < 6}
                    className={`w-full py-5 bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white font-bold text-lg rounded-2xl shadow-xl transition-all ${registerLoading ? "opacity-50 cursor-wait" : "hover:scale-[1.02]"} disabled:opacity-50 disabled:cursor-not-allowed`}
                  >
                    {registerLoading ? "Verifying..." : "Verify & Create Account →"}
                  </button>

                  <div className="text-center space-y-2">
                    <p className="text-sm text-gray-500">
                      Didn't receive it?{" "}
                      <button
                        type="button"
                        onClick={handleResendBookingOtp}
                        disabled={registerLoading || bookingOtpCooldown > 0}
                        className="font-bold text-purple-600 hover:text-pink-600 transition-colors underline underline-offset-2 disabled:text-gray-400 disabled:no-underline"
                      >
                        {bookingOtpCooldown > 0 ? `Resend in ${bookingOtpCooldown}s` : "Resend Code"}
                      </button>
                    </p>
                    <button type="button" onClick={() => { setBookingRegStep("form"); setBookingOtp(""); setFormErrors({}); }} className="text-xs text-gray-400 hover:text-purple-500 transition-colors">
                      ← Change email address
                    </button>
                  </div>
                </div>

              /* ── Registration form state ── */
              ) : (
                <>
                  {formErrors.register && (
                    <div className="p-4 bg-red-50 border-2 border-red-100 text-red-600 rounded-2xl font-bold flex items-center gap-2">
                      <span>⚠️</span> {formErrors.register}
                    </div>
                  )}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div id="field-fullName" className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Full Name</label>
                  <input type="text" name="fullName" value={customerInfo.fullName} onChange={handleCustomerChange}
                    className={`w-full p-4 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.fullName ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                    placeholder="John Doe" />
                  {formErrors.fullName && <p className="text-red-500 text-xs font-bold ml-1 italic">⚠️ {formErrors.fullName}</p>}
                </div>
                <div id="field-email" className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Email Address</label>
                  <input type="email" name="email" value={customerInfo.email} onChange={handleCustomerChange}
                    className={`w-full p-4 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.email ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                    placeholder="john@example.com" />
                  {formErrors.email && <p className="text-red-500 text-xs font-bold ml-1 italic">⚠️ {formErrors.email}</p>}
                </div>
              </div>
              <div id="field-phone" className="space-y-2">
                <label className="text-sm font-bold text-gray-700 ml-1">Contact Number</label>
                <input type="tel" name="phone" value={customerInfo.phone} onChange={handleCustomerChange} maxLength={11}
                  className={`w-full p-4 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all ${formErrors.phone ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                  placeholder="09123456789" />
                {formErrors.phone && <p className="text-red-500 text-xs font-bold ml-1 italic">⚠️ {formErrors.phone}</p>}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div id="field-password" className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Create Password</label>
                  <div className="relative">
                    <input type={showPassword ? "text" : "password"} name="password" value={customerInfo.password} onChange={handleCustomerChange}
                      className={`w-full p-4 pr-14 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all [&::-ms-reveal]:hidden [&::-webkit-credentials-auto-fill-button]:hidden ${formErrors.password ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                      placeholder="••••••••" />
                    <button type="button" onClick={() => setShowPassword(v => !v)} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 hover:bg-purple-100 rounded-xl transition-all">
                      {showPassword ? (
                        <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" /></svg>
                      ) : (
                        <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                      )}
                    </button>
                  </div>
                  {formErrors.password && <p className="text-red-500 text-xs font-bold ml-1 italic">⚠️ {formErrors.password}</p>}
                </div>
                <div id="field-confirmPassword" className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Confirm Password</label>
                  <div className="relative">
                    <input type={showConfirmPassword ? "text" : "password"} name="confirmPassword" value={customerInfo.confirmPassword} onChange={handleCustomerChange}
                      className={`w-full p-4 pr-14 text-lg bg-gray-50 border-2 rounded-2xl outline-none focus:border-purple-400 transition-all [&::-ms-reveal]:hidden [&::-webkit-credentials-auto-fill-button]:hidden ${formErrors.confirmPassword ? "border-red-400 bg-red-50" : "border-purple-100"}`}
                      placeholder="••••••••" />
                    <button type="button" onClick={() => setShowConfirmPassword(v => !v)} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 hover:bg-purple-100 rounded-xl transition-all">
                      {showConfirmPassword ? (
                        <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" /></svg>
                      ) : (
                        <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                      )}
                    </button>
                  </div>
                  {formErrors.confirmPassword && <p className="text-red-500 text-xs font-bold ml-1">⚠️ {formErrors.confirmPassword}</p>}
                </div>
              </div>
              <button
                onClick={handleRegister}
                disabled={registerLoading}
                className={`w-full py-5 bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white font-bold text-lg rounded-2xl shadow-xl transition-all ${registerLoading ? "opacity-50 cursor-wait" : "hover:scale-[1.02] hover:shadow-purple-400/40"} disabled:opacity-50`}
              >
                {registerLoading ? "Sending Code..." : "Next: Verify Email"}
              </button>
              <p className="text-center text-gray-500">
                Already have an account?{" "}
                <button type="button" onClick={() => { setShowRegisterModal(false); setShowAuthModal(true); setFormErrors({}); }}
                  className="font-bold text-purple-600 hover:text-pink-600 transition-colors underline underline-offset-2">Sign in here</button>
              </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* STEP 2: PET PROFILES */}
      {step === 2 && (
        <div className="space-y-8 animate-in fade-in slide-in-from-right-4 duration-500">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-bold text-gray-800 flex items-center">
              <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mr-3 text-sm">{getVisualStepNum(2)}</span>
              {user && user.pets && user.pets.length > 0 ? "Select a Pet to Book" : "Pet Profiles"}
            </h3>
            {(!user || !user.pets || user.pets.length === 0) && (
              <button 
                onClick={addPet}
                className="px-4 py-2 bg-purple-50 text-purple-600 font-bold rounded-xl hover:bg-purple-100 transition-all flex items-center"
              >
                <span className="mr-2">+</span> Add Another Pet
              </button>
            )}
          </div>

          {user && user.pets && user.pets.length > 0 ? (
            <div className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {user.pets.map(p => (
                  <button
                    key={p._id}
                    onClick={() => {
                      const isCustom = !["dog", "cat"].includes(p.petType) || 
                        (p.petType === "dog" ? !DOG_BREEDS.includes(p.breed) : !CAT_BREEDS.includes(p.breed));

                      const basePet = {
                        ...newPet(),
                        petName: p.petName,
                        petType: p.petType,
                        breed: isCustom ? "Other" : p.breed,
                        isCustomBreed: isCustom && p.breed !== "",
                        customBreed: isCustom ? p.breed : "",
                        gender: p.gender || "unknown",
                        birthday: p.birthday ? new Date(p.birthday).toISOString().split("T")[0] : "",
                        photoUrl: p.photoUrl || "",
                        behaviorNotes: p.behaviorNotes || "",
                      };

                      const configuredPet = applyServiceToPet(basePet, selectedServiceCategory, dbServices);
                      setPets([configuredPet]);
                      setStep(3);
                    }}
                    className="bg-white/50 border-2 border-purple-100 rounded-[2rem] p-6 hover:border-purple-400 transition-all flex flex-col items-center gap-4 text-center hover:shadow-xl group"
                  >
                    <div className="w-24 h-24 bg-purple-50 rounded-full flex items-center justify-center text-4xl overflow-hidden group-hover:scale-110 transition-transform shadow-inner">
                      {p.photoUrl ? <img src={p.photoUrl} alt={p.petName} className="w-full h-full object-cover" /> : (p.petType === "cat" ? "🐱" : "🐶")}
                    </div>
                    <div>
                      <p className="text-xl font-bold text-gray-800">{p.petName}</p>
                      <p className="text-sm text-gray-500 capitalize">{p.petType} · {p.breed || "Mixed"}</p>
                    </div>
                    <div className="mt-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl text-sm font-bold w-full shadow-md group-hover:scale-105 transition-all">
                      Select Pet
                    </div>
                  </button>
                ))}

                {/* ─── Add Pet Card ───────────────────────────── */}
                <button
                  onClick={() => {
                    setAddPetForm({ petName: "", petType: "dog", breed: "", isCustomBreed: false, customBreed: "", gender: "unknown", birthday: "", photoUrl: "" });
                    setAddPetError(null);
                    setShowAddPetModal(true);
                  }}
                  className="bg-white/30 border-2 border-dashed border-purple-200 rounded-[2rem] p-6 hover:border-purple-400 hover:bg-purple-50/40 transition-all flex flex-col items-center gap-4 text-center group"
                >
                  <div className="w-24 h-24 bg-purple-100 rounded-full flex items-center justify-center text-4xl group-hover:scale-110 transition-transform">
                    <span className="text-5xl text-purple-400 font-thin leading-none">+</span>
                  </div>
                  <div>
                    <p className="text-lg font-bold text-purple-600">Add New Pet</p>
                    <p className="text-xs text-gray-400 mt-1">Register a new pet to your account</p>
                  </div>
                </button>
              </div>

            </div>
          ) : (
            <>
              {pets.map((pet, index) => (
                <div key={pet.id} className="p-8 bg-white/50 border-2 border-purple-50 rounded-[2rem] space-y-6 relative">
                  {pets.length > 1 && (
                    <button 
                      onClick={() => removePet(index)}
                      className="absolute top-6 right-6 text-red-400 hover:text-red-600 font-bold"
                    >
                      Remove
                    </button>
                  )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div id={`field-petName_${index}`} className="space-y-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Pet Name</label>
                  <input 
                    type="text" value={pet.petName} onChange={(e) => handlePetChange(index, "petName", e.target.value)}
                    placeholder="Buddy"
                    className={`w-full px-6 py-4 bg-white border-2 rounded-2xl focus:border-purple-400 outline-none transition-all ${
                      formErrors[`petName_${index}`] ? "border-red-400 bg-red-50" : "border-purple-50"
                    }`}
                  />
                  {formErrors[`petName_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`petName_${index}`]}</p>}
                </div>
                <div id={`field-petType_${index}`} className="space-y-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Type</label>
                  <div className={`flex space-x-4 p-1 rounded-2xl ${formErrors[`petType_${index}`] ? "bg-red-50 ring-2 ring-red-400" : ""}`}>
                    {["dog", "cat"].map(t => (
                      <button
                        key={t}
                        onClick={() => handlePetChange(index, "petType", t)}
                        className={`flex-1 py-4 rounded-2xl font-bold border-2 transition-all capitalize ${
                          pet.petType === t ? "bg-purple-600 border-purple-600 text-white shadow-lg" : "bg-white border-purple-50 text-gray-500 hover:border-purple-200"
                        }`}
                      >
                        {t === "dog" ? "🐶 " : "🐱 "}{t}
                      </button>
                    ))}
                  </div>
                  {formErrors[`petType_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`petType_${index}`]}</p>}
                </div>
                <div id={pet.isCustomBreed ? `field-customBreed_${index}` : `field-breed_${index}`} className="space-y-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Breed</label>
                  {!pet.isCustomBreed ? (
                    <>
                      <select 
                        value={pet.breed} onChange={(e) => {
                          if (e.target.value === "Other") handlePetChange(index, "isCustomBreed", true);
                          else handlePetChange(index, "breed", e.target.value);
                        }}
                        className={`w-full px-6 py-4 bg-white border-2 rounded-2xl focus:border-purple-400 outline-none transition-all ${
                          formErrors[`breed_${index}`] ? "border-red-400 bg-red-50" : "border-purple-50"
                        }`}
                      >
                        <option value="">Select Breed</option>
                        {(pet.petType === "dog" ? DOG_BREEDS : CAT_BREEDS).map(b => (
                          <option key={b} value={b}>{b}</option>
                        ))}
                      </select>
                      {formErrors[`breed_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`breed_${index}`]}</p>}
                    </>
                  ) : (
                    <div className="relative">
                      <input 
                        type="text" value={pet.customBreed} onChange={(e) => handlePetChange(index, "customBreed", e.target.value)}
                        placeholder="Enter breed..."
                        className={`w-full px-6 py-4 bg-white border-2 rounded-2xl focus:border-purple-400 outline-none transition-all ${
                          formErrors[`customBreed_${index}`] ? "border-red-400 bg-red-50" : "border-purple-50"
                        }`}
                      />
                      <button 
                        onClick={() => handlePetChange(index, "isCustomBreed", false)}
                        className="absolute right-4 top-4 text-xs text-purple-500 font-bold"
                      >
                        List
                      </button>
                      {formErrors[`customBreed_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`customBreed_${index}`]}</p>}
                    </div>
                  )}
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Gender <span className="text-gray-400 font-normal">(Optional)</span></label>
                  <select 
                    value={pet.gender} onChange={(e) => handlePetChange(index, "gender", e.target.value)}
                    className="w-full px-6 py-4 bg-white border-2 rounded-2xl focus:border-purple-400 outline-none transition-all border-purple-50"
                  >
                    <option value="unknown">Unknown</option>
                    <option value="male">Male ♂️</option>
                    <option value="female">Female ♀️</option>
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Birthdate *</label>
                  <input 
                    type="date" 
                    value={pet.birthday} onChange={(e) => handlePetChange(index, "birthday", e.target.value)}
                    max={new Date().toISOString().split("T")[0]}
                    className={`w-full px-6 py-4 bg-white border-2 rounded-2xl focus:border-purple-400 outline-none transition-all ${
                      formErrors[`birthday_${index}`] ? "border-red-400 bg-red-50/50" : "border-purple-50"
                    }`}
                    required
                  />
                  {formErrors[`birthday_${index}`] && (
                    <p className="text-xs text-red-500 font-bold ml-1">{formErrors[`birthday_${index}`]}</p>
                  )}
                </div>
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Behavior Notes <span className="text-gray-400 font-normal">(Optional)</span></label>
                  <input 
                    type="text" value={pet.behaviorNotes} onChange={(e) => handlePetChange(index, "behaviorNotes", e.target.value)}
                    placeholder="Friendly, nervous around other dogs, etc."
                    className="w-full px-6 py-4 bg-white border-2 border-purple-50 rounded-2xl focus:border-purple-400 outline-none transition-all"
                  />
                </div>
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-bold text-gray-600 ml-1">Pet Photo <span className="text-gray-400 font-normal">(Optional)</span></label>
                  <div className="flex items-start gap-4">
                    {pet.photoUrl && (
                      <div className="relative flex-shrink-0">
                        <img
                          src={pet.photoUrl}
                          alt="Pet preview"
                          className="w-24 h-24 object-cover rounded-2xl border-2 border-purple-100 shadow"
                        />
                        <button
                          type="button"
                          onClick={() => handlePetChange(index, "photoUrl", "")}
                          className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full text-xs font-black flex items-center justify-center hover:bg-red-600"
                        >
                          ×
                        </button>
                      </div>
                    )}
                    <label className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-purple-200 rounded-2xl p-6 cursor-pointer hover:border-purple-400 hover:bg-purple-50/50 transition-all bg-white">
                      <span className="text-3xl mb-2">📷</span>
                      <span className="text-sm font-bold text-purple-500">{pet.photoUrl ? "Change photo" : "Upload pet photo"}</span>
                      <span className="text-[10px] text-gray-400 mt-1">JPG, PNG • auto-compressed</span>
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          const compressed = await compressImage(file);
                          handlePetChange(index, "photoUrl", compressed);
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
            </>
          )}

          <div className="flex justify-between">
            <button onClick={() => setStep(0)} className="px-8 py-4 text-purple-600 font-bold">← Back</button>
            {(!user || !user.pets || user.pets.length === 0) && (
              <button 
                onClick={handleNext}
                className="px-12 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-xl hover:scale-105 transition-all"
              >
                Next: Services →
              </button>
            )}
          </div>
        </div>
      )}

      {/* STEP 3: SERVICES & AVAILABILITY */}
      {step === 3 && (
        <div className="space-y-8 animate-in fade-in slide-in-from-right-4 duration-500">
          <h3 className="text-2xl font-bold text-gray-800 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mr-3 text-sm">{getVisualStepNum(3)}</span>
            Services & Scheduling
          </h3>

          {pets.map((pet, index) => (
            <div key={pet.id} className="p-8 bg-white/50 border-2 border-purple-50 rounded-[2rem] space-y-8">
              <h4 className="text-xl font-black text-purple-700">Booking for {pet.petName || `Pet ${index + 1}`}</h4>
              
                <div id={`field-serviceType_${index}`} className="space-y-4">
                  <label className="text-sm font-bold text-gray-600 ml-1">Service Type</label>
                  <div className={`p-1 rounded-2xl ${formErrors[`serviceType_${index}`] ? "bg-red-50 ring-2 ring-red-400" : ""}`}>
                    <select 
                      value={pet.serviceType || ""} 
                      onChange={(e) => handlePetChange(index, "serviceType", e.target.value)}
                      className="w-full px-6 py-4 bg-white border-2 border-purple-50 rounded-2xl outline-none focus:border-purple-400 transition-all shadow-inner font-bold text-gray-700 capitalize cursor-pointer"
                    >
                      <option value="" disabled>Select Service Type</option>
                      <option value="grooming">Grooming</option>
                      <option value="hotel">Boarding / Hotel</option>
                      <option value="both">Grooming + Boarding</option>
                    </select>
                  </div>
                  {formErrors[`serviceType_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`serviceType_${index}`]}</p>}
                </div>

              {/* Grooming Details */}
              {(pet.serviceType === "grooming" || pet.serviceType === "both") && (
                <div className="space-y-6 p-6 bg-purple-50/50 rounded-2xl border border-purple-100">
                  <h5 className="font-bold text-purple-800">Grooming Configuration</h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div id={`field-groomingService_${index}`} className="space-y-2">
                      <label className="text-sm font-bold text-gray-600">Select Package <span className="text-red-500">*</span></label>
                      <div className={`space-y-2 rounded-2xl transition-all ${formErrors[`groomingService_${index}`] ? "ring-2 ring-red-400 bg-red-50 p-2" : ""}`}>
                        {(dbServices.grooming[pet.petType] || []).map(service => (
                          <button
                            key={service._id || service.id}
                            onClick={() => handlePetChange(index, "groomingService", service)}
                            className={`w-full p-4 rounded-xl text-left border-2 transition-all ${
                              pet.groomingService?.name === service.name ? "bg-white border-purple-500 shadow-md" : "bg-white/50 border-transparent hover:border-purple-200"
                            }`}
                          >
                            <div className="font-bold">{service.name}</div>
                            <div className="text-xs text-gray-500">{service.description}</div>
                          </button>
                        ))}
                      </div>
                      {formErrors[`groomingService_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`groomingService_${index}`]}</p>}
                    </div>
                    {pet.groomingService?.sizes && (
                      <div id={`field-groomingSize_${index}`} className="space-y-2">
                        <label className="text-sm font-bold text-gray-600">Pet Size <span className="text-red-500">*</span></label>
                        <div className={`grid grid-cols-2 gap-2 rounded-2xl transition-all ${formErrors[`groomingSize_${index}`] ? "ring-2 ring-red-400 bg-red-50 p-2" : ""}`}>
                          {pet.groomingService.sizes.map(size => (
                            <button
                              key={size.label}
                              onClick={() => {
                                handlePetChange(index, "groomingSize", size);
                                const isLargeOrXL = size?.label?.toLowerCase().includes("large");
                                const allowedSlots = isLargeOrXL ? GROOMING_TIMES_2HR : GROOMING_TIMES_1HR;
                                if (pet.groomingTime && !allowedSlots.includes(pet.groomingTime)) {
                                  handlePetChange(index, "groomingTime", null);
                                }
                              }}
                              className={`p-3 rounded-xl text-sm font-bold border-2 transition-all ${
                                pet.groomingSize?.label === size.label ? "bg-purple-600 border-purple-600 text-white" : "bg-white border-purple-50 text-gray-500"
                              }`}
                            >
                              {size.label} <br/> <span className="text-xs opacity-70">₱{size.price}</span>
                            </button>
                          ))}
                        </div>
                        {formErrors[`groomingSize_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`groomingSize_${index}`]}</p>}
                      </div>
                    )}
                  </div>

                  <div className={`grid grid-cols-1 ${pet.groomingService?.name !== 'Basic Grooming' ? 'md:grid-cols-2' : ''} gap-6`}>
                    {pet.groomingService?.name !== 'Basic Grooming' && (
                      <div className="space-y-4">
                        <div className="space-y-2">
                          <label className="text-sm font-bold text-gray-600">Haircut Style</label>
                          <select 
                            value={pet.haircutStyle || ""} onChange={(e) => handlePetChange(index, "haircutStyle", e.target.value)}
                            className="w-full px-6 py-4 bg-white border-2 border-purple-50 rounded-2xl outline-none"
                          >
                            <option value="">Select Style</option>
                            {(pet.petType === "dog" ? DOG_STYLES : CAT_STYLES).map(s => (
                              <option key={s} value={s}>{s}</option>
                            ))}
                          </select>
                          {pet.haircutStyle === "Custom" && (
                            <div className="pt-2 animate-in fade-in slide-in-from-top-2">
                              <input
                                type="text"
                                value={pet.haircutInstructions || ""}
                                onChange={(e) => handlePetChange(index, "haircutInstructions", e.target.value)}
                                placeholder="Describe the custom style..."
                                className="w-full px-6 py-4 bg-white border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all shadow-inner"
                                required
                              />
                            </div>
                          )}
                        </div>
                        {pet.haircutStyle && STYLE_IMAGES[pet.petType][pet.haircutStyle] && (
                          <div className="relative group overflow-hidden rounded-2xl border-2 border-purple-100 animate-in zoom-in-95 duration-300">
                            <img 
                              src={STYLE_IMAGES[pet.petType][pet.haircutStyle]} 
                              alt={pet.haircutStyle}
                              className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                            />
                            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                              <span className="text-white text-xs font-bold uppercase tracking-wider">{pet.haircutStyle} Preview</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    <div id={`field-groomingDate_${index}`} className="space-y-2">
                      <div className="flex justify-between items-center">
                        <label className="text-sm font-bold text-gray-600">Date <span className="text-red-500">*</span></label>
                        <span className="text-[11px] font-bold text-amber-700 bg-amber-50 px-2.5 py-0.5 rounded-full border border-amber-200">
                          🚫 Closed Mondays
                        </span>
                      </div>
                      <input 
                        type="date" 
                        value={pet.groomingDate || ""}
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val) {
                            const day = new Date(val + "T00:00:00").getDay();
                            if (day === 1) {
                              setFormErrors(prev => ({ ...prev, [`groomingDate_${index}`]: "Store is closed on Mondays. Please choose another date." }));
                              handlePetChange(index, "groomingDate", "");
                              handlePetChange(index, "groomingTime", null);
                              return;
                            }
                          }
                          setFormErrors(prev => {
                            const c = { ...prev };
                            delete c[`groomingDate_${index}`];
                            return c;
                          });
                          handlePetChange(index, "groomingDate", val);
                          fetchAvailability(index, "grooming", val);
                        }}
                        className={`w-full px-6 py-4 bg-white border-2 rounded-2xl outline-none transition-all ${
                          formErrors[`groomingDate_${index}`] ? "border-red-400 bg-red-50" : "border-purple-50"
                        }`}
                      />
                      {formErrors[`groomingDate_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`groomingDate_${index}`]}</p>}
                    </div>
                  </div>

                  {pet.groomingDate && (
                    <div id={`field-groomingTime_${index}`} className="space-y-2">
                      <div className="flex justify-between items-center">
                        <label className="text-sm font-bold text-gray-600">Time Availability</label>
                        <span className="text-[11px] font-bold text-purple-700 bg-purple-100/80 px-3 py-1 rounded-full border border-purple-200">
                          {pet.groomingSize?.label?.toLowerCase().includes("large") ? "⏱️ 2-Hour Intervals (Large / XL)" : "⏱️ 1-Hour Intervals"}
                        </span>
                      </div>
                      <div className={`grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-2 p-1 rounded-xl ${formErrors[`groomingTime_${index}`] ? "bg-red-50 ring-2 ring-red-400" : ""}`}>
                        {(pet.groomingSize?.label?.toLowerCase().includes("large") ? GROOMING_TIMES_2HR : GROOMING_TIMES_1HR).map(t => {
                          const avail = availability[`grooming-${pet.groomingDate}-`]?.slots?.find(s => s.time === t);
                          const isAvailable = avail ? avail.available : true;
                          return (
                            <button
                              key={t}
                              disabled={!isAvailable}
                              onClick={() => handlePetChange(index, "groomingTime", t)}
                              className={`p-2 rounded-lg text-[10px] font-bold border-2 transition-all ${
                                pet.groomingTime === t 
                                  ? "bg-purple-600 border-purple-600 text-white" 
                                  : isAvailable 
                                    ? "bg-emerald-50 border-emerald-500 text-emerald-700 hover:bg-emerald-500 hover:text-white"
                                    : "bg-red-50 border-red-500 text-red-700 cursor-not-allowed opacity-50"
                              }`}
                            >
                              {t}
                            </button>
                          );
                        })}
                      </div>
                      {formErrors[`groomingTime_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`groomingTime_${index}`]}</p>}
                    </div>
                  )}
                </div>
              )}

              {/* Hotel Details */}
              {(pet.serviceType === "hotel" || pet.serviceType === "both") && (
                <div className="space-y-6 p-6 bg-blue-50/50 rounded-2xl border border-blue-100">
                  <h5 className="font-bold text-blue-800">Hotel Accommodation</h5>
                  
                  <div id={`field-hotelRoom_${index}`} className="space-y-2">
                    <label className="text-sm font-bold text-gray-600">Available Slots (Room Types)</label>
                    <div className={`grid grid-cols-2 sm:grid-cols-3 gap-4 rounded-2xl transition-all ${formErrors[`hotelRoom_${index}`] ? "ring-2 ring-red-400 bg-red-50 p-2" : ""}`}>
                      {(dbServices.hotel || []).filter(r => r.category === pet.petType || (r.id && r.id.startsWith(pet.petType))).map(room => (
                        <button
                          key={room._id || room.id}
                          onClick={() => handlePetChange(index, "hotelRoom", room)}
                          className={`p-4 rounded-2xl text-left border-2 transition-all ${
                            pet.hotelRoom?.name === room.name ? "bg-white border-blue-500 shadow-md" : "bg-white/50 border-transparent hover:border-blue-200"
                          }`}
                        >
                          <div className="mb-2">{renderRoomIcon(room.icon)}</div>
                          <div className="font-bold text-sm">{room.name}</div>
                          <div className="text-[10px] text-gray-500">₱{room.price}/night</div>
                        </button>
                      ))}
                    </div>
                    {formErrors[`hotelRoom_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`hotelRoom_${index}`]}</p>}
                  </div>

                  {pet.hotelRoom && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Check-in Date */}
                        <div id={`field-checkInDate_${index}`} className="space-y-2">
                          <div className="flex justify-between items-center">
                            <label className="text-sm font-bold text-gray-600">Check-in Date <span className="text-red-500">*</span></label>
                            <span className="text-[10px] font-bold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full border border-amber-200">
                              Closed Mon · Check-out OK
                            </span>
                          </div>
                          <input 
                            type="date" 
                            value={pet.checkInDate || ""}
                            min={new Date().toISOString().split("T")[0]}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val) {
                                const day = new Date(val + "T00:00:00").getDay();
                                if (day === 1) {
                                  setFormErrors(prev => ({ ...prev, [`checkInDate_${index}`]: "Store is closed on Mondays. Please select another check-in date. Check-out on Monday is allowed for hotel stays." }));
                                  handlePetChange(index, "checkInDate", "");
                                  return;
                                }
                              }
                              setFormErrors(prev => {
                                const c = { ...prev };
                                delete c[`checkInDate_${index}`];
                                return c;
                              });
                              handlePetChange(index, "checkInDate", val);
                              fetchAvailability(index, "hotel", val, pet.hotelRoom.id);
                            }}
                            className={`w-full px-6 py-4 bg-white border-2 rounded-2xl outline-none transition-all ${
                              formErrors[`checkInDate_${index}`] ? "border-red-400 bg-red-50" : "border-blue-50"
                            }`}
                          />
                          {formErrors[`checkInDate_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`checkInDate_${index}`]}</p>}
                        </div>

                        {/* Number of Days to Stay (Replacing Check-out Date) */}
                        <div id={`field-stayDays_${index}`} className="space-y-2">
                          <div className="flex justify-between items-center">
                            <label className="text-sm font-bold text-gray-600">Number of Days to Stay <span className="text-red-500">*</span></label>
                            <span className="text-[10px] font-bold text-blue-700 bg-blue-50 px-2 py-0.5 rounded-full border border-blue-200">
                              ₱{pet.hotelRoom.price}/day
                            </span>
                          </div>
                          <div className="flex items-center gap-3">
                            <div className="flex items-center bg-white border-2 border-blue-100 rounded-2xl p-1 shadow-sm flex-1">
                              <button
                                type="button"
                                onClick={() => {
                                  const current = Number(pet.stayDays) || 1;
                                  const nextVal = Math.max(1, current - 1);
                                  handlePetChange(index, "stayDays", nextVal);
                                }}
                                className="w-12 h-12 rounded-xl bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 font-black text-xl flex items-center justify-center transition-all"
                              >
                                −
                              </button>
                              <input
                                type="number"
                                min="1"
                                max="90"
                                value={pet.stayDays || 1}
                                onChange={(e) => {
                                  const val = Math.max(1, parseInt(e.target.value) || 1);
                                  handlePetChange(index, "stayDays", val);
                                }}
                                className="w-full text-center font-black text-lg text-gray-800 outline-none bg-transparent"
                              />
                              <button
                                type="button"
                                onClick={() => {
                                  const current = Number(pet.stayDays) || 1;
                                  handlePetChange(index, "stayDays", current + 1);
                                }}
                                className="w-12 h-12 rounded-xl bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 font-black text-xl flex items-center justify-center transition-all"
                              >
                                +
                              </button>
                            </div>
                            <span className="text-sm font-bold text-gray-600 pr-2">Day{(pet.stayDays || 1) > 1 ? "s" : ""}</span>
                          </div>
                          {pet.checkInDate && (
                            <p className="text-xs text-blue-700 font-medium bg-blue-50/70 p-2 rounded-xl border border-blue-100/60 flex items-center gap-1.5">
                              <span>📅</span>
                              <span>
                                Expected Check-out: <strong>{(() => {
                                  const d = new Date(pet.checkInDate + "T00:00:00");
                                  d.setDate(d.getDate() + (Number(pet.stayDays) || 1));
                                  return d.toLocaleDateString("en-PH", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
                                })()}</strong>
                                {pet.checkInTime ? ` at ${pet.checkInTime}` : ""}
                              </span>
                            </p>
                          )}
                          {formErrors[`stayDays_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`stayDays_${index}`]}</p>}
                        </div>
                      </div>

                      {/* Check-in Time */}
                      {pet.checkInDate && (
                        <div id={`field-checkInTime_${index}`} className="space-y-2">
                          <label className="text-sm font-bold text-gray-600">
                            Check-in Time <span className="text-red-500">*</span>
                          </label>
                          <div className="relative">
                            <select
                              value={pet.checkInTime || ""}
                              onChange={e => handlePetChange(index, "checkInTime", e.target.value)}
                              className={`w-full px-4 py-3 pr-10 border-2 rounded-2xl outline-none text-sm font-bold text-gray-800 appearance-none bg-white transition-all cursor-pointer ${
                                formErrors[`checkInTime_${index}`]
                                  ? "border-red-400 bg-red-50"
                                  : pet.checkInTime
                                    ? "border-blue-500 bg-blue-50/50"
                                    : "border-gray-200 hover:border-blue-300"
                              }`}
                            >
                              <option value="">-- Select a time --</option>
                              {HOTEL_CHECKIN_TIMES.map(t => (
                                <option key={t} value={t}>{t}</option>
                              ))}
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                              <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </div>
                          </div>
                          <p className="text-[11px] text-gray-400 font-medium">⏰ Check-in anytime between 9:00 AM – 7:00 PM</p>
                          {formErrors[`checkInTime_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`checkInTime_${index}`]}</p>}
                        </div>
                      )}

                      {/* Hotel Price Summary Badge */}
                      <div className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl flex justify-between items-center">
                        <div className="space-y-0.5">
                          <span className="text-xs font-bold text-blue-900">Hotel Stay Total</span>
                          <p className="text-[11px] text-blue-700">
                            ₱{pet.hotelRoom.price} × {pet.stayDays || 1} day(s)
                          </p>
                        </div>
                        <span className="text-lg font-black text-blue-700">
                          ₱{((pet.hotelRoom.price || 0) * (Number(pet.stayDays) || 1)).toLocaleString()}
                        </span>
                      </div>
                    </>
                  )}

                  <div className="space-y-4 pt-4 border-t border-blue-100">
                    <div className="p-4 bg-blue-100/50 rounded-xl text-xs text-blue-800 font-bold">
                      ⚠️ Note: Please bring your pet's own food.
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-gray-600">Feeding Instructions</label>
                      <textarea 
                        value={pet.feedingInstructions} onChange={(e) => handlePetChange(index, "feedingInstructions", e.target.value)}
                        className="w-full px-6 py-4 bg-white border-2 border-blue-50 rounded-2xl outline-none min-h-[100px]"
                        placeholder="Twice a day, 1 cup each..."
                      ></textarea>
                    </div>

                  </div>
                </div>
              )}

              {/* Health & Behavior - Shared for all services */}
              {pet.serviceType && (
                <div className="space-y-6 p-6 bg-emerald-50/50 rounded-2xl border border-emerald-100">
                  <div className="flex items-center justify-between">
                    <h5 className="font-bold text-emerald-800">Health & Behavior</h5>
                    <span className="text-[10px] font-black uppercase tracking-wider text-rose-700 bg-rose-50 px-2.5 py-1 rounded-full border border-rose-200">
                      Strict Policy
                    </span>
                  </div>

                  {/* Vaccination Policy Notice Banner */}
                  <div className="p-3.5 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-2.5 text-xs text-amber-900">
                    <span className="text-base shrink-0 mt-0.5">⚠️</span>
                    <div className="space-y-0.5">
                      <p className="font-bold text-amber-950">Store Vaccination Requirement</p>
                      <p className="text-[11px] leading-relaxed text-amber-800">
                        For the health and safety of all animals, <strong>dogs and cats that are not vaccinated will NOT be accepted in the store</strong>. Please upload an up-to-date vaccination record (especially Anti-Rabies) for each pet.
                      </p>
                    </div>
                  </div>

                <div className="grid grid-cols-1 gap-4">
                  <div className="space-y-2">
                    <label className="text-[10px] font-bold text-gray-500 uppercase">Vaccination Photo / Record <span className="text-red-500">*</span></label>
                    <div className="flex items-start gap-4">
                      {pet.vaccinationPhotoUrl && (
                        <div className="relative flex-shrink-0">
                          <img
                            src={pet.vaccinationPhotoUrl}
                            alt="Vaccination Record"
                            className="w-24 h-24 object-cover rounded-xl border-2 border-emerald-100 shadow"
                          />
                          <button
                            type="button"
                            onClick={() => handlePetChange(index, "vaccinationPhotoUrl", "")}
                            className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-[10px] font-black flex items-center justify-center hover:bg-red-600"
                          >
                            ×
                          </button>
                        </div>
                      )}
                      <label className={`flex-1 flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-4 cursor-pointer transition-all bg-white ${
                        formErrors[`vaccinationPhotoUrl_${index}`] ? "border-red-400 bg-red-50" : "border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50/50"
                      }`}>
                        <span className="text-2xl mb-1">📋</span>
                        <span className="text-xs font-bold text-emerald-600">{pet.vaccinationPhotoUrl ? "Change photo" : "Upload vaccination record"}</span>
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            const compressed = await compressImage(file);
                            handlePetChange(index, "vaccinationPhotoUrl", compressed);
                          }}
                        />
                      </label>
                    </div>
                    {formErrors[`vaccinationPhotoUrl_${index}`] && <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`vaccinationPhotoUrl_${index}`]}</p>}
                  </div>
                  {/* Health Status — required */}
                  <div className="space-y-3">
                    <label className="text-[10px] font-bold text-gray-500 uppercase">
                      Health Status <span className="text-red-500">*</span>
                    </label>
                    <div className="grid grid-cols-2 gap-3">
                      {/* Healthy */}
                      <button
                        type="button"
                        onClick={() => {
                          handlePetChange(index, { healthStatus: "healthy", medicalConditions: "", medication: "" });
                          clearFieldError(`healthStatus_${index}`, `medicalConditions_${index}`, `medication_${index}`);
                        }}
                        className={`flex items-center gap-2 px-4 py-3 rounded-xl border-2 font-bold text-sm transition-all ${
                          pet.healthStatus === "healthy"
                            ? "border-emerald-500 bg-emerald-50 text-emerald-700 shadow-sm"
                            : "border-gray-200 bg-white text-gray-500 hover:border-emerald-300"
                        }`}
                      >
                        <span className="text-base">✅</span> Healthy
                      </button>
                      {/* Not Healthy */}
                      <button
                        type="button"
                        onClick={() => {
                          handlePetChange(index, "healthStatus", "not_healthy");
                          clearFieldError(`healthStatus_${index}`);
                        }}
                        className={`flex items-center gap-2 px-4 py-3 rounded-xl border-2 font-bold text-sm transition-all ${
                          pet.healthStatus === "not_healthy"
                            ? "border-rose-500 bg-rose-50 text-rose-700 shadow-sm"
                            : "border-gray-200 bg-white text-gray-500 hover:border-rose-300"
                        }`}
                      >
                        <span className="text-base">🩺</span> Not Healthy
                      </button>
                    </div>
                    {formErrors[`healthStatus_${index}`] && (
                      <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`healthStatus_${index}`]}</p>
                    )}
                  </div>

                  {/* Medical Conditions + Medication — only shown when Not Healthy */}
                  {pet.healthStatus === "not_healthy" && (
                    <>
                      <div className="space-y-2">
                        <label className="text-[10px] font-bold text-gray-500 uppercase">
                          Medical Condition / Notes <span className="text-red-500">*</span>
                        </label>
                        <textarea
                          value={pet.medicalConditions || ""}
                          onChange={(e) => handlePetChange(index, "medicalConditions", e.target.value)}
                          rows={3}
                          placeholder="Please describe your pet's current medical condition (e.g. skin allergy, diabetes, recovering from surgery...)"
                          className={`w-full px-4 py-3 bg-white border-2 rounded-xl outline-none resize-none focus:border-rose-400 transition-all text-sm ${
                            formErrors[`medicalConditions_${index}`] ? "border-red-400 bg-red-50" : "border-rose-200"
                          }`}
                        />
                        {formErrors[`medicalConditions_${index}`] && (
                          <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`medicalConditions_${index}`]}</p>
                        )}
                      </div>
                      <div className="space-y-2">
                        <label className="text-[10px] font-bold text-gray-500 uppercase">
                          Medication <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text" value={pet.medication || ""} onChange={(e) => handlePetChange(index, "medication", e.target.value)}
                          placeholder="e.g. Amoxicillin 250mg twice daily"
                          className={`w-full px-4 py-2 bg-white border-2 rounded-xl outline-none focus:border-rose-400 transition-all ${
                            formErrors[`medication_${index}`] ? "border-red-400 bg-red-50" : "border-rose-200"
                          }`}
                        />
                        {formErrors[`medication_${index}`] && (
                          <p className="text-red-500 text-[10px] font-bold ml-1 italic">⚠️ {formErrors[`medication_${index}`]}</p>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
              )}
            </div>
          ))}

          <div className="flex justify-between">
            <button onClick={() => setStep(2)} className="px-8 py-4 text-purple-600 font-bold">← Back</button>
            <button 
              onClick={handleNext}
              className="px-12 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-xl hover:scale-105 transition-all"
            >
              Next: Shop Add-Ons →
            </button>
          </div>
        </div>
      )}

      {/* STEP 4: SHOP ADD-ONS */}
      {step === 4 && (
        <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
          {/* Header */}
          <div className="text-center space-y-2">
            <h3 className="text-2xl font-bold text-gray-800 flex items-center justify-center gap-3">
              <span className="w-8 h-8 bg-amber-100 text-amber-600 rounded-lg flex items-center justify-center text-sm">{getVisualStepNum(4)}</span>
              Want to add anything for your pet?
            </h3>
            <p className="text-gray-500 text-sm">Grab treats, food, or care products to go along with your booking — completely optional! 🛍️</p>
          </div>

          {/* Category filter pills */}
          <div className="flex flex-wrap gap-2 justify-center">
            {ADDON_CATEGORIES.map(cat => (
              <button
                key={cat.id}
                onClick={() => setAddonCategory(cat.id)}
                className={`px-4 py-2 rounded-2xl font-bold text-sm border-2 transition-all flex items-center gap-1.5 ${
                  addonCategory === cat.id
                    ? "bg-gradient-to-r from-purple-600 to-pink-600 border-transparent text-white shadow-lg scale-[1.03]"
                    : "bg-white border-purple-100 text-gray-600 hover:border-purple-300 hover:bg-purple-50"
                }`}
              >
                <span>{cat.emoji}</span> {cat.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Product grid */}
            <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto pr-1">
              {shopProducts
                .filter(p => addonCategory === "All" || p.category === addonCategory)
                .map(product => {
                  const colors = ADDON_CAT_COLORS[product.category];
                  const vIdx = addonVariantIdx[product.id] ?? 0;
                  const variant = product.variants[vIdx];
                  const cartLine = selectedAddons.find(a => a.productId === product.id && a.variantLabel === variant.label);
                  return (
                    <div
                      key={product.id}
                      className="bg-white border-2 border-purple-50 rounded-[1.5rem] p-4 flex flex-col gap-3 hover:border-purple-200 hover:shadow-lg transition-all"
                    >
                      {/* Icon + name */}
                      <div className="flex items-center gap-3">
                        <div
                          className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0"
                          style={{ background: `linear-gradient(135deg, ${colors.bg}, white)`, border: `1.5px solid ${colors.border}` }}
                        >
                          {product.emoji}
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-1 mb-0.5">
                            <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: colors.dot }} />
                            <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: colors.text }}>{product.category}</span>
                          </div>
                          <p className="text-sm font-bold text-gray-800 leading-tight">{product.name}</p>
                        </div>
                        <div className="text-right flex-shrink-0">
                          <p className="text-base font-black text-purple-700">₱{variant.price}</p>
                        </div>
                      </div>

                      {/* Variant pills */}
                      {product.variants.length > 1 && (
                        <div className="flex flex-wrap gap-1.5">
                          {product.variants.map((v, i) => (
                            <button
                              key={i}
                              onClick={() => setAddonVariantIdx(prev => ({ ...prev, [product.id]: i }))}
                              className="px-2.5 py-1 rounded-full text-[11px] font-bold transition-all border"
                              style={{
                                background: vIdx === i ? "linear-gradient(135deg,#7C3AED,#EC4899)" : colors.bg,
                                color: vIdx === i ? "white" : colors.text,
                                borderColor: vIdx === i ? "transparent" : colors.border,
                              }}
                            >
                              {v.label}
                            </button>
                          ))}
                        </div>
                      )}

                      {/* Add to cart / qty stepper */}
                      {cartLine ? (
                        <div className="flex items-center justify-between bg-purple-50 rounded-2xl px-3 py-2">
                          <button
                            onClick={() => setAddonQty(product.id, variant.label, cartLine.qty - 1)}
                            className="w-8 h-8 rounded-xl bg-white border-2 border-purple-200 text-purple-700 font-black text-lg flex items-center justify-center hover:bg-purple-100 transition-all"
                          >−</button>
                          <span className="font-black text-purple-700 text-base">{cartLine.qty}</span>
                          <button
                            onClick={() => setAddonQty(product.id, variant.label, cartLine.qty + 1)}
                            className="w-8 h-8 rounded-xl bg-purple-600 text-white font-black text-lg flex items-center justify-center hover:bg-purple-700 transition-all"
                          >+</button>
                        </div>
                      ) : (
                        <button
                          onClick={() => addAddon(product, vIdx)}
                          className="w-full py-2.5 rounded-2xl font-bold text-sm bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:scale-[1.02] hover:shadow-md transition-all"
                        >
                          + Add to Order
                        </button>
                      )}
                    </div>
                  );
                })}
            </div>

            {/* Order summary panel */}
            <div className="lg:col-span-1">
              <div className="sticky top-4 bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-100 rounded-[2rem] p-5 space-y-4">
                <h4 className="font-black text-gray-800 flex items-center gap-2">
                  <span>🛒</span> Your Order
                </h4>

                {selectedAddons.length === 0 ? (
                  <div className="text-center py-6 space-y-2">
                    <div className="text-4xl">🛍️</div>
                    <p className="text-sm text-gray-400 font-medium">No add-ons selected yet</p>
                    <p className="text-xs text-gray-400">Browse products on the left, or skip to continue</p>
                  </div>
                ) : (
                  <div className="space-y-2 max-h-52 overflow-y-auto">
                    {selectedAddons.map((a, i) => (
                      <div key={i} className="flex items-center justify-between gap-2 text-sm">
                        <div className="flex items-center gap-1.5 min-w-0">
                          <span>{a.emoji}</span>
                          <div className="min-w-0">
                            <p className="font-bold text-gray-800 text-xs leading-tight truncate">{a.productName}</p>
                            <p className="text-[10px] text-gray-500 truncate">{a.variantLabel}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 flex-shrink-0">
                          <span className="text-xs text-gray-500">×{a.qty}</span>
                          <span className="font-black text-purple-700 text-xs">₱{(a.price * a.qty).toLocaleString()}</span>
                          <button
                            onClick={() => setAddonQty(a.productId, a.variantLabel, 0)}
                            className="text-red-400 hover:text-red-600 text-sm font-black transition-colors"
                          >×</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Totals */}
                <div className="pt-3 border-t border-purple-200 space-y-1.5">
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Services</span>
                    <span className="font-bold">₱{pets.reduce((acc, p) => {
                      let price = 0;
                      if (p.serviceType === "grooming" || p.serviceType === "both") price += (p.groomingSize?.price || p.groomingService?.price || 0);
                      if (p.serviceType === "hotel" || p.serviceType === "both") price += (p.hotelRoom?.price || 0) * (Number(p.stayDays) || 1);
                      return acc + price;
                    }, 0).toLocaleString()}</span>
                  </div>
                  {selectedAddons.length > 0 && (
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>Add-Ons ({selectedAddons.reduce((s, a) => s + a.qty, 0)} items)</span>
                      <span className="font-bold">₱{getAddonsTotal().toLocaleString()}</span>
                    </div>
                  )}
                  <div className="flex justify-between text-base font-black text-gray-800 pt-1 border-t border-purple-200">
                    <span>Grand Total</span>
                    <span className="text-purple-700">₱{(pets.reduce((acc, p) => {
                      let price = 0;
                      if (p.serviceType === "grooming" || p.serviceType === "both") price += (p.groomingSize?.price || p.groomingService?.price || 0);
                      if (p.serviceType === "hotel" || p.serviceType === "both") price += (p.hotelRoom?.price || 0) * (Number(p.stayDays) || 1);
                      return acc + price;
                    }, 0) + getAddonsTotal()).toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-between items-center pt-2">
            <button onClick={() => setStep(3)} className="px-8 py-4 text-purple-600 font-bold">← Back</button>
            <div className="flex gap-3">
              <button
                onClick={() => { setSelectedAddons([]); setStep(5); }}
                className="px-6 py-4 border-2 border-gray-200 text-gray-500 font-bold rounded-2xl hover:border-gray-300 hover:bg-gray-50 transition-all text-sm"
              >
                Skip — No Thanks
              </button>
              <button
                onClick={() => setStep(5)}
                className="px-10 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-xl hover:scale-105 transition-all"
              >
                {selectedAddons.length > 0 ? `Continue with ${selectedAddons.reduce((s, a) => s + a.qty, 0)} item(s) →` : "Continue →"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* STEP 5: REVIEW & TERMS */}
      {step === 5 && (
        <div className="space-y-8 animate-in fade-in slide-in-from-right-4 duration-500">
          <h3 className="text-2xl font-bold text-gray-800 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center mr-3 text-sm">{getVisualStepNum(5)}</span>
            Final Review
          </h3>

          <div className="p-8 bg-purple-50 rounded-[2rem] border-2 border-purple-100 space-y-6">
            <div className="flex justify-between items-center pb-4 border-b border-purple-100">
              <span className="font-bold text-gray-600">Customer</span>
              <span className="font-black text-gray-800">{customerInfo.fullName}</span>
            </div>
            <div className="space-y-4">
              <span className="font-bold text-gray-600 block">Pets & Services</span>
              {pets.map((p, i) => (
                <div key={p.id} className="flex justify-between items-center text-sm">
                  <span>{p.petName} ({p.petType})</span>
                  <span className="font-bold text-purple-700 capitalize">{p.serviceType}</span>
                </div>
              ))}
            </div>
            {selectedAddons.length > 0 && (
              <div className="space-y-2">
                <span className="font-bold text-gray-600 block">Add-On Products</span>
                {selectedAddons.map((a, i) => (
                  <div key={i} className="flex justify-between items-center text-sm">
                    <span className="flex items-center gap-1.5"><span>{a.emoji}</span>{a.productName} <span className="text-gray-400 text-xs">({a.variantLabel}) ×{a.qty}</span></span>
                    <span className="font-bold text-gray-700">₱{(a.price * a.qty).toLocaleString()}</span>
                  </div>
                ))}
              </div>
            )}
            <div className="pt-4 border-t-4 border-dashed border-purple-200 space-y-1">
              {selectedAddons.length > 0 && (
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Services Subtotal</span>
                  <span className="font-bold">₱{pets.reduce((acc, p) => {
                    let price = 0;
                    if (p.serviceType === "grooming" || p.serviceType === "both") price += (p.groomingSize?.price || p.groomingService?.price || 0);
                    if (p.serviceType === "hotel" || p.serviceType === "both") price += (p.hotelRoom?.price || 0) * (Number(p.stayDays) || 1);
                    return acc + price;
                  }, 0).toLocaleString()}</span>
                </div>
              )}
              {selectedAddons.length > 0 && (
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Add-Ons Subtotal</span>
                  <span className="font-bold">₱{getAddonsTotal().toLocaleString()}</span>
                </div>
              )}
              <div className="flex justify-between items-center pt-1">
                <span className="text-xl font-bold text-gray-600">Total Price</span>
                <span className="text-3xl font-black text-purple-600">
                  ₱{(pets.reduce((acc, p) => {
                    let price = 0;
                    if (p.serviceType === "grooming" || p.serviceType === "both") {
                      price += (p.groomingSize?.price || p.groomingService?.price || 0);
                    }
                    if (p.serviceType === "hotel" || p.serviceType === "both") {
                      const days = Number(p.stayDays) || 1;
                      price += (p.hotelRoom?.price || 0) * days;
                    }
                    return acc + price;
                  }, 0) + getAddonsTotal()).toLocaleString()}
                </span>
              </div>
            </div>
          </div>

          {/* ─── Payment Method Section ─────────────────────────────────── */}
          {(() => {
            const totalAmt = pets.reduce((acc, p) => {
              let price = 0;
              if (p.serviceType === "grooming" || p.serviceType === "both") price += (p.groomingSize?.price || p.groomingService?.price || 0);
              if (p.serviceType === "hotel" || p.serviceType === "both") {
                const days = Number(p.stayDays) || 1;
                price += (p.hotelRoom?.price || 0) * days;
              }
              return acc + price;
            }, 0) + getAddonsTotal();

            const minDown = Math.ceil(totalAmt * 0.10);
            let payNowAmt = minDown;
            let payLabel = "10% Downpayment";

            if (paymentOption === "50%") {
              payNowAmt = Math.ceil(totalAmt * 0.50);
              payLabel = "50% Half Payment";
            } else if (paymentOption === "100%") {
              payNowAmt = totalAmt;
              payLabel = "Full Payment";
            } else if (paymentOption === "custom") {
              const parsed = Number(customPayAmount);
              payNowAmt = (!customPayAmount || isNaN(parsed)) ? minDown : Math.min(Math.max(parsed, minDown), totalAmt);
              payLabel = payNowAmt >= totalAmt ? "Full Payment" : "Custom Downpayment";
            }

            const remaining = Math.max(0, totalAmt - payNowAmt);

            return (
              <div id="field-payment" className={`rounded-[2rem] border-2 overflow-hidden transition-all ${formErrors.payment ? "border-red-400 ring-2 ring-red-300" : "border-purple-100"}`}>
                {/* Header */}
                <div className="px-8 pt-7 pb-5 bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50 border-b border-purple-100">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">💳</span>
                    <div>
                      <h4 className="font-black text-gray-800 text-lg">Payment Details</h4>
                      <p className="text-xs text-gray-500">Select payment plan (10% minimum downpayment, custom, or full payment)</p>
                    </div>
                  </div>
                </div>

                <div className="px-8 py-6 bg-white space-y-6">
                  
                  {/* Payment Option Selector */}
                  <div>
                    <label className="text-sm font-bold text-gray-700 mb-3 block">Choose Payment Option</label>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                      {[
                        { id: "10%",  label: "10% Downpayment", badge: `₱${minDown.toLocaleString()}` },
                        { id: "50%",  label: "50% Half Pay",     badge: `₱${Math.ceil(totalAmt * 0.50).toLocaleString()}` },
                        { id: "100%", label: "Full Payment",     badge: `₱${totalAmt.toLocaleString()}` },
                        { id: "custom", label: "Custom Amount", badge: "10%+ Up" },
                      ].map(opt => (
                        <button
                          key={opt.id}
                          type="button"
                          onClick={() => { setPaymentOption(opt.id); clearFieldError("payment"); }}
                          className={`p-3.5 rounded-2xl border-2 flex flex-col items-center justify-center text-center transition-all font-bold text-xs gap-1 ${
                            paymentOption === opt.id
                              ? "bg-purple-600 border-purple-600 text-white shadow-lg scale-[1.02]"
                              : "bg-white border-purple-100 text-gray-700 hover:border-purple-300 hover:bg-purple-50/40"
                          }`}
                        >
                          <span className="font-black text-sm">{opt.label}</span>
                          <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono ${paymentOption === opt.id ? "bg-white/20 text-white" : "bg-purple-100 text-purple-700"}`}>
                            {opt.badge}
                          </span>
                        </button>
                      ))}
                    </div>

                    {/* Custom Amount Input field */}
                    {paymentOption === "custom" && (
                      <div className="mt-4 p-4 bg-purple-50/70 border-2 border-purple-200 rounded-2xl space-y-2 animate-in fade-in duration-200">
                        <div className="flex justify-between items-center">
                          <label className="text-xs font-bold text-gray-700">Enter Payment Amount (₱)</label>
                          <span className="text-[10px] font-bold text-purple-600">Min 10%: ₱{minDown.toLocaleString()}</span>
                        </div>
                        <div className="relative">
                          <span className="absolute left-4 top-1/2 -translate-y-1/2 font-black text-purple-600">₱</span>
                          <input
                            type="number"
                            min={minDown}
                            max={totalAmt}
                            value={customPayAmount}
                            onChange={(e) => { setCustomPayAmount(e.target.value); clearFieldError("payment"); }}
                            placeholder={`e.g. ${minDown}`}
                            className="w-full pl-9 pr-4 py-3 bg-white border-2 border-purple-200 rounded-xl outline-none focus:border-purple-500 font-bold text-lg text-gray-800"
                          />
                        </div>
                        <p className="text-[11px] text-gray-500">You can pay any amount between ₱{minDown.toLocaleString()} (10%) and ₱{totalAmt.toLocaleString()} (Full price).</p>
                      </div>
                    )}
                  </div>

                  {/* Summary Banner */}
                  <div className="rounded-2xl bg-gradient-to-r from-purple-600 via-purple-700 to-pink-600 p-5 text-white shadow-lg">
                    <div className="grid grid-cols-3 gap-4 text-center">
                      <div>
                        <p className="text-xs font-bold opacity-75 uppercase tracking-wider mb-1">Total Price</p>
                        <p className="text-xl font-black">₱{totalAmt.toLocaleString()}</p>
                      </div>
                      <div className="border-x border-white/30">
                        <p className="text-xs font-bold opacity-75 uppercase tracking-wider mb-1">Pay Now ({payLabel})</p>
                        <p className="text-2xl font-black text-yellow-300">₱{payNowAmt.toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-xs font-bold opacity-75 uppercase tracking-wider mb-1">On Service Day</p>
                        <p className="text-xl font-black">
                          {remaining === 0 ? "₱0 (Fully Paid 🎉)" : `₱${remaining.toLocaleString()}`}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Payment method selector */}
                  <div>
                    <label className="text-sm font-bold text-gray-700 mb-3 block">Choose Payment Method</label>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                      {[
                        { id: "Cash",      label: "Cash",      emoji: "💵", color: "from-emerald-500 to-teal-600", border: "border-emerald-400" },
                        { id: "GCash",     label: "GCash",     emoji: "💙", color: "from-blue-500 to-cyan-500", border: "border-blue-400" },
                        { id: "UnionBank", label: "UnionBank", emoji: "🏦", color: "from-orange-500 to-amber-500", border: "border-orange-400" },
                        { id: "BDO",       label: "BDO",       emoji: "🏦", color: "from-blue-700 to-indigo-800", border: "border-blue-700" },
                      ].map(pm => (
                        <button
                          key={pm.id}
                          type="button"
                          onClick={() => { setPaymentMethod(pm.id); setPaymentScreenshot(null); clearFieldError("payment"); }}
                          className={`relative p-4 rounded-2xl border-2 flex flex-col items-center gap-2 transition-all font-bold text-sm ${
                            paymentMethod === pm.id
                              ? `bg-gradient-to-br ${pm.color} ${pm.border} text-white shadow-lg scale-[1.02]`
                              : "bg-white border-gray-200 text-gray-600 hover:border-gray-300"
                          }`}
                        >
                          <span className="text-3xl">{pm.emoji}</span>
                          <span>{pm.label}</span>
                          {paymentMethod === pm.id && (
                            <span className="absolute top-2 right-2 w-5 h-5 bg-white/30 rounded-full flex items-center justify-center text-[10px]">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Payment Method Details */}
                  {paymentMethod === "Cash" ? (
                    <div className="rounded-2xl p-5 border-2 bg-emerald-50 border-emerald-100 space-y-3">
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl bg-emerald-500 text-white flex items-center justify-center text-2xl shadow shrink-0">
                          💵
                        </div>
                        <div>
                          <p className="font-black text-sm text-emerald-900">
                            Cash Payment at Counter
                          </p>
                          <p className="text-xs text-emerald-700 font-medium mt-0.5">
                            Amount to pay: <span className="font-bold">₱{payNowAmt.toLocaleString()}</span> ({payLabel}). Pay directly at the clinic counter.
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : paymentMethod === "GCash" ? (
                    /* GCash QR Code & Instructions */
                    <div className="rounded-2xl p-5 border-2 bg-blue-50 border-blue-100 space-y-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-black text-sm text-blue-700 flex items-center gap-1.5">
                            <span>💙</span> Scan GCash QR Code to Pay
                          </p>
                          <p className="text-xs text-gray-500 mt-0.5">Send exactly ₱{payNowAmt.toLocaleString()} ({payLabel})</p>
                        </div>
                        <button
                          type="button"
                          onClick={() => setShowQrModal(true)}
                          className="px-3 py-1.5 text-xs font-bold rounded-xl border-2 transition-all border-blue-300 text-blue-700 bg-white hover:bg-blue-100"
                        >
                          🔍 Enlarge
                        </button>
                      </div>
                      <div className="flex justify-center">
                        <img
                          src="/gcash_qr.png"
                          alt="GCash QR Code"
                          className="w-48 h-48 object-contain rounded-2xl shadow-md border-4 border-white cursor-pointer hover:scale-105 transition-transform"
                          onClick={() => setShowQrModal(true)}
                        />
                      </div>
                      <div className="bg-white/80 p-3 rounded-xl border border-blue-100 text-xs space-y-1">
                        <div className="flex justify-between">
                          <span className="text-gray-500">Account Name:</span>
                          <span className="font-bold text-gray-800">Furpect Tails Pet Care Center</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">GCash Number:</span>
                          <span className="font-bold font-mono text-blue-700">0954 498 8342</span>
                        </div>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-gray-500">After paying ₱{payNowAmt.toLocaleString()}, upload your screenshot and enter your reference number below</p>
                      </div>
                    </div>
                  ) : paymentMethod === "UnionBank" ? (
                    /* UnionBank Transfer Card */
                    <div className="rounded-2xl p-5 border-2 bg-orange-50 border-orange-200 space-y-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-black text-sm text-orange-800 flex items-center gap-1.5">
                            <span>🏦</span> UnionBank Online / Bank Transfer
                          </p>
                          <p className="text-xs text-gray-500 mt-0.5">Transfer exactly ₱{payNowAmt.toLocaleString()} ({payLabel})</p>
                        </div>
                        <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-orange-100 text-orange-800">
                          InstaPay / PESONet
                        </span>
                      </div>
                      <div className="bg-white p-4 rounded-xl border border-orange-200 shadow-sm space-y-2.5 text-xs">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Bank:</span>
                          <span className="font-bold text-gray-800">UnionBank of the Philippines</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Account Name:</span>
                          <span className="font-bold text-gray-800">Furpect Tails Pet Care Center</span>
                        </div>
                        <div className="flex justify-between items-center pt-1 border-t border-orange-100">
                          <span className="text-gray-500">Account Number:</span>
                          <div className="flex items-center gap-2">
                            <span className="font-mono font-black text-sm text-orange-700 tracking-wider">1094 2345 6789</span>
                            <button
                              type="button"
                              onClick={() => {
                                navigator.clipboard.writeText("109423456789");
                                setCopiedBank("UnionBank");
                                setTimeout(() => setCopiedBank(null), 2000);
                              }}
                              className="px-2 py-0.5 text-[10px] font-bold rounded bg-orange-100 text-orange-800 hover:bg-orange-200 transition-colors"
                            >
                              {copiedBank === "UnionBank" ? "✓ Copied" : "Copy"}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-gray-500">Transfer via UnionBank app or InstaPay from any bank, then upload your transaction slip below</p>
                      </div>
                    </div>
                  ) : (
                    /* BDO Transfer Card */
                    <div className="rounded-2xl p-5 border-2 bg-indigo-50 border-indigo-200 space-y-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-black text-sm text-indigo-900 flex items-center gap-1.5">
                            <span>🏦</span> BDO Online / Bank Transfer
                          </p>
                          <p className="text-xs text-gray-500 mt-0.5">Transfer exactly ₱{payNowAmt.toLocaleString()} ({payLabel})</p>
                        </div>
                        <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-indigo-100 text-indigo-800">
                          InstaPay / PESONet
                        </span>
                      </div>
                      <div className="bg-white p-4 rounded-xl border border-indigo-200 shadow-sm space-y-2.5 text-xs">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Bank:</span>
                          <span className="font-bold text-gray-800">BDO Unibank, Inc.</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Account Name:</span>
                          <span className="font-bold text-gray-800">Furpect Tails Pet Care Center</span>
                        </div>
                        <div className="flex justify-between items-center pt-1 border-t border-indigo-100">
                          <span className="text-gray-500">Account Number:</span>
                          <div className="flex items-center gap-2">
                            <span className="font-mono font-black text-sm text-indigo-800 tracking-wider">0012 3456 7890</span>
                            <button
                              type="button"
                              onClick={() => {
                                navigator.clipboard.writeText("001234567890");
                                setCopiedBank("BDO");
                                setTimeout(() => setCopiedBank(null), 2000);
                              }}
                              className="px-2 py-0.5 text-[10px] font-bold rounded bg-indigo-100 text-indigo-800 hover:bg-indigo-200 transition-colors"
                            >
                              {copiedBank === "BDO" ? "✓ Copied" : "Copy"}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-gray-500">Transfer via BDO Online / Pay app or InstaPay from any bank, then upload your transaction slip below</p>
                      </div>
                    </div>
                  )}

                  {/* Screenshot upload (Non-Cash) */}
                  {paymentMethod !== "Cash" && (
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-gray-700 block">Payment Screenshot / Bank Receipt <span className="text-red-500">*</span></label>
                      <div className="flex items-start gap-4">
                        {paymentScreenshot && (
                          <div className="relative flex-shrink-0">
                            <img
                              src={paymentScreenshot}
                              alt="Payment Screenshot"
                              className="w-24 h-24 object-cover rounded-xl border-2 border-purple-200 shadow"
                            />
                            <button
                              type="button"
                              onClick={() => setPaymentScreenshot(null)}
                              className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-[10px] font-black flex items-center justify-center hover:bg-red-600"
                            >
                              ×
                            </button>
                          </div>
                        )}
                        <label className={`flex-1 flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-4 cursor-pointer transition-all bg-white ${
                          formErrors.payment && !paymentScreenshot ? "border-red-400 bg-red-50" : "border-purple-200 hover:border-purple-400 hover:bg-purple-50/50"
                        }`}>
                          <span className="text-2xl mb-1">📸</span>
                          <span className="text-xs font-bold text-purple-600">
                            {paymentScreenshot ? "Change screenshot" : "Upload payment receipt / screenshot"}
                          </span>
                          <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              const compressed = await compressImage(file);
                              setPaymentScreenshot(compressed);
                              clearFieldError("payment");
                            }}
                          />
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Reference number — for non-Cash (GCash / UnionBank / BDO) */}
                  {paymentMethod !== "Cash" && (
                  <div id="field-referenceNumber" className="space-y-2">
                    <label className="text-sm font-bold text-gray-700 block">
                      Reference / Transaction Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="reference-number-input"
                      type="text"
                      value={referenceNumber}
                      onChange={(e) => { setReferenceNumber(e.target.value); clearFieldError("payment"); }}
                      placeholder="e.g. 1234567890"
                      className={`w-full px-6 py-4 border-2 rounded-2xl outline-none transition-all font-mono tracking-wider ${
                        formErrors.payment && !referenceNumber.trim() ? "border-red-400 bg-red-50" : "border-purple-100 focus:border-purple-400 bg-white"
                      }`}
                    />
                    <p className="text-xs text-gray-400">
                      {`Enter the reference/transaction number from your ${paymentMethod} receipt`}
                    </p>
                  </div>
                  )}

                  {formErrors.payment && (
                    <p className="text-red-500 text-xs font-bold bg-red-50 border border-red-100 px-4 py-2 rounded-xl">⚠️ {formErrors.payment}</p>
                  )}
                </div>
              </div>
            );
          })()}

          {/* QR Enlarge Modal */}
          {showQrModal && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 animate-in fade-in duration-200" onClick={() => setShowQrModal(false)}>
              <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
              <div className="relative z-10 animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()}>
                <button
                  onClick={() => setShowQrModal(false)}
                  className="absolute -top-4 -right-4 w-9 h-9 bg-white text-gray-700 rounded-full font-black text-lg flex items-center justify-center shadow-xl hover:bg-gray-100 transition-all z-20"
                >
                  ×
                </button>
                <img
                  src="/gcash_qr.png"
                  alt="GCash QR Code"
                  className="w-80 h-80 object-contain rounded-3xl shadow-2xl border-4 border-white"
                />
                <p className="text-center text-white font-bold mt-3 text-sm">Scan with GCash app</p>
              </div>
            </div>
          )}

          {/* T&C Modal */}
          {showTerms && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                onClick={() => setShowTerms(false)}
              />
              {/* Panel */}
              <div className="relative z-10 w-full max-w-lg bg-white rounded-[2rem] shadow-2xl flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-200">
                {/* Modal header */}
                <div className="flex items-center justify-between px-8 pt-7 pb-5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-t-[2rem]">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">📋</span>
                    <div>
                      <h3 className="font-black text-white text-lg">Terms &amp; Conditions</h3>
                      <p className="text-purple-200 text-xs">Furpect Tails Pet Services</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setShowTerms(false)}
                    className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 text-white font-black flex items-center justify-center transition-all text-lg"
                  >
                    ×
                  </button>
                </div>
                {/* Scrollable terms list */}
                <div className="overflow-y-auto px-8 py-6 space-y-4 flex-1">
                  {[
                    "I confirm that I own the pet or I was given authority by the owner for taking ownership of the pet.",
                    "I assure Furpect Tails that my pet/s is currently in good health condition.",
                    "I confirm that my pet has a complete and updated vaccination (especially Anti-Rabies). I understand that pets without updated vaccination will NOT be accepted into the store/facility.",
                    "I acknowledge that the pet should have a safety collar for protection purposes if there are signs of aggression.",
                    "I confirm that my pet doesn't have any flea or any communicable disease.",
                    "The facility is not liable for any pre-existing medical conditions and undisclosed illnesses that may result in death, or any other unfortunate events during the stay.",
                    "If ever that I wasn't able to pick up my pet on time, Furpect Tails will call the owner and get authorization for the pet to stay with us.",
                    "I confirmed that all information I entered in this form is true and accurate.",
                    "In case of a medical emergency the facility will make reasonable efforts to contact the pet owner. If the owner cannot be reached, the facility is authorized to seek veterinary care at the owner's expense.",
                    "The facility is not responsible for loss or damage to personal pet items (e.g. toys, bedding, collars). Owners are advised to label all personal items brought for boarding.",
                    "The facility reserves the right to refuse service or terminate this agreement if the pet is unmanageable, poses a safety risk, or violates the terms stated herein.",
                    "I agree to the terms indicated above and will follow them.",
                  ].map((term, i) => (
                    <div key={i} className="flex items-start gap-4">
                      <span className="flex-shrink-0 w-7 h-7 rounded-xl bg-purple-100 text-purple-700 text-xs font-black flex items-center justify-center mt-0.5">
                        {i + 1}
                      </span>
                      <p className="text-sm text-gray-600 leading-relaxed pt-1">{term}</p>
                    </div>
                  ))}
                </div>
                {/* Modal signature section */}
                <div className="px-8 pb-2 pt-2 border-t border-purple-100 bg-purple-50/40">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <span className="text-base">✍️</span>
                      <div>
                        <p className="font-black text-gray-800 text-sm">Sign Here</p>
                        <p className="text-xs text-gray-400">Signing confirms you agree to the terms above</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        modalSignaturePadRef.current?.clear();
                      }}
                      className="px-3 py-1.5 text-xs font-bold text-purple-600 bg-white border-2 border-purple-200 rounded-xl hover:bg-purple-50 transition-all flex items-center gap-1"
                    >
                      <span>↺</span> Clear
                    </button>
                  </div>
                  <div className="relative rounded-2xl overflow-hidden border-2 border-dashed border-purple-200 bg-white" style={{ minHeight: 150 }}>
                    <div className="absolute bottom-10 left-6 right-6 border-b-2 border-dashed border-purple-100 pointer-events-none" />
                    <p className="absolute bottom-2 left-0 right-0 text-center text-[10px] text-purple-200 font-bold uppercase tracking-widest pointer-events-none select-none">
                      Sign above this line
                    </p>
                    <SignaturePad
                      ref={modalSignaturePadRef}
                      height={150}
                      onChange={(dataURL) => {
                        if (dataURL) {
                          setOwnerSignature(dataURL);
                          setAcceptedTerms(true);
                          clearFieldError("signature", "terms");
                          // Sync to main card pad after a tick
                          setTimeout(() => {
                            signaturePadRef.current?.clear();
                          }, 50);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* Modal footer */}
                <div className="px-8 py-4 border-t border-purple-50 flex gap-3">
                  <button
                    type="button"
                    onClick={() => setShowTerms(false)}
                    className="flex-1 py-3 bg-white border-2 border-purple-200 text-purple-600 font-bold rounded-2xl hover:bg-purple-50 transition-all"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const dataURL = modalSignaturePadRef.current?.getDataURL();
                      if (dataURL) {
                        setOwnerSignature(dataURL);
                        setAcceptedTerms(true);
                        clearFieldError("signature", "terms");
                      }
                      setShowTerms(false);
                    }}
                    className="flex-1 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-black rounded-2xl hover:scale-[1.02] transition-all shadow-lg"
                  >
                    Confirm &amp; Close ✓
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Digital Signature card */}
          <div id="field-signature" className={`rounded-[2rem] border-2 overflow-hidden transition-all ${
            formErrors.terms || formErrors.signature ? "border-red-400 ring-2 ring-red-300" : "border-purple-100"
          }`}>

            {/* Card header */}
            <div className="px-8 pt-7 pb-5 bg-gradient-to-r from-purple-50 to-pink-50 border-b border-purple-100">
              <div className="flex items-center gap-3">
                <span className="text-2xl">✍️</span>
                <div>
                  <h4 className="font-black text-gray-800 text-lg">Digital Signature</h4>
                  <p className="text-xs text-gray-500">Sign below to confirm your booking agreement</p>
                </div>
              </div>
            </div>

            {/* Read-only checkbox with T&C hyperlink */}
            <div className="px-8 py-6 bg-white">
              <div className="flex items-start gap-3">
                <div className={`mt-0.5 w-5 h-5 rounded border-2 flex-shrink-0 flex items-center justify-center transition-all ${
                  acceptedTerms ? "bg-purple-600 border-purple-600" : "bg-white border-gray-300"
                }`}>
                  {acceptedTerms && (
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </div>
                <span className="text-sm text-gray-700 leading-relaxed">
                  I have read and agree to the{" "}
                  <button
                    type="button"
                    onClick={() => setShowTerms(true)}
                    className="text-purple-600 font-bold underline underline-offset-2 hover:text-pink-600 transition-colors"
                  >
                    Terms &amp; Conditions
                  </button>
                  .{" "}
                  {!acceptedTerms && (
                    <span className="text-xs text-purple-400 italic font-normal">Open Terms &amp; Conditions to sign.</span>
                  )}
                </span>
              </div>
              {(formErrors.terms || formErrors.signature) && (
                <p className="text-red-500 text-xs font-bold mt-2 ml-8">⚠️ {formErrors.signature || "You must sign the Terms & Conditions to proceed."}</p>
              )}
            </div>
          </div>

          <div className="flex justify-between items-center">
            <button onClick={() => setStep(4)} className="px-8 py-4 text-purple-600 font-bold">← Back</button>
            <button 
              disabled={loading}
              onClick={handleSubmit}
              className={`px-16 py-5 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-black text-xl rounded-2xl shadow-2xl transition-all ${
                loading ? "opacity-50 cursor-wait" : "hover:scale-105 hover:shadow-purple-500/50"
              }`}
            >
              {loading ? "Processing..." : "Complete Booking 🐾"}
            </button>
          </div>
        </div>
      )}

      {/* ─── Add Pet Modal ─────────────────────────────────────────── */}
      {showAddPetModal && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 animate-in fade-in duration-200" onClick={(e) => { if (e.target === e.currentTarget) setShowAddPetModal(false); }}>
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowAddPetModal(false)} />
          <div className="relative z-10 w-full max-w-lg bg-white rounded-[2rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">

            {/* Header */}
            <div className="flex items-center justify-between px-8 pt-7 pb-5 bg-gradient-to-r from-purple-600 to-pink-600">
              <div className="flex items-center gap-3">
                <span className="text-2xl">🐾</span>
                <div>
                  <h3 className="font-black text-white text-lg">Add New Pet</h3>
                  <p className="text-purple-200 text-xs">This pet will be saved to your profile</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowAddPetModal(false)}
                className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 text-white font-black flex items-center justify-center transition-all text-lg"
              >
                ×
              </button>
            </div>

            {/* Form */}
            <div className="px-8 py-6 space-y-5 max-h-[65vh] overflow-y-auto">

              {/* Pet Name */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Pet Name <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  value={addPetForm.petName}
                  onChange={(e) => { setAddPetForm(f => ({ ...f, petName: e.target.value })); setAddPetError(null); }}
                  placeholder="e.g. Buddy"
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all font-medium"
                />
              </div>

              {/* Pet Type */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Type <span className="text-red-500">*</span></label>
                <div className="flex gap-3">
                  {["dog", "cat"].map(t => (
                    <button
                      key={t}
                      type="button"
                      onClick={() => { setAddPetForm(f => ({ ...f, petType: t, breed: "", isCustomBreed: false, customBreed: "" })); }}
                      className={`flex-1 py-3 rounded-2xl font-bold border-2 capitalize transition-all ${
                        addPetForm.petType === t ? "bg-purple-600 border-purple-600 text-white shadow-lg" : "bg-white border-purple-100 text-gray-500 hover:border-purple-300"
                      }`}
                    >
                      {t === "dog" ? "🐶 Dog" : "🐱 Cat"}
                    </button>
                  ))}
                </div>
              </div>

              {/* Breed */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Breed <span className="text-red-500">*</span></label>
                {!addPetForm.isCustomBreed ? (
                  <div className="relative">
                    <select
                      value={addPetForm.breed}
                      onChange={(e) => {
                        if (e.target.value === "Other") setAddPetForm(f => ({ ...f, isCustomBreed: true, breed: "" }));
                        else setAddPetForm(f => ({ ...f, breed: e.target.value }));
                        setAddPetError(null);
                      }}
                      className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all font-medium appearance-none"
                    >
                      <option value="">Select Breed</option>
                      {(addPetForm.petType === "dog" ? DOG_BREEDS : CAT_BREEDS).map(b => (
                        <option key={b} value={b}>{b}</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <div className="relative">
                    <input
                      type="text"
                      value={addPetForm.customBreed}
                      onChange={(e) => { setAddPetForm(f => ({ ...f, customBreed: e.target.value })); setAddPetError(null); }}
                      placeholder="Enter breed name..."
                      className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all font-medium"
                    />
                    <button
                      type="button"
                      onClick={() => setAddPetForm(f => ({ ...f, isCustomBreed: false, customBreed: "" }))}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-xs text-purple-500 font-bold"
                    >
                      List
                    </button>
                  </div>
                )}
              </div>

              {/* Gender */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Gender</label>
                <select
                  value={addPetForm.gender}
                  onChange={(e) => setAddPetForm(f => ({ ...f, gender: e.target.value }))}
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all font-medium"
                >
                  <option value="unknown">Unknown</option>
                  <option value="male">Male ♂️</option>
                  <option value="female">Female ♀️</option>
                </select>
              </div>

              {/* Birthday */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Birthdate *</label>
                <input
                  type="date"
                  value={addPetForm.birthday}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setAddPetForm(f => ({ ...f, birthday: e.target.value }))}
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 transition-all font-medium"
                  required
                />
              </div>

              {/* Pet Photo */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Pet Photo <span className="text-gray-400 font-normal text-xs">(Optional)</span></label>
                <div className="flex items-start gap-4">
                  {addPetForm.photoUrl && (
                    <div className="relative flex-shrink-0">
                      <img src={addPetForm.photoUrl} alt="Pet" className="w-20 h-20 object-cover rounded-2xl border-2 border-purple-100 shadow" />
                      <button type="button" onClick={() => setAddPetForm(f => ({ ...f, photoUrl: "" }))}
                        className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-[10px] font-black flex items-center justify-center">×</button>
                    </div>
                  )}
                  <label className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-purple-200 rounded-2xl p-4 cursor-pointer hover:border-purple-400 hover:bg-purple-50/50 transition-all bg-white">
                    <span className="text-2xl mb-1">📷</span>
                    <span className="text-xs font-bold text-purple-500">{addPetForm.photoUrl ? "Change photo" : "Upload pet photo"}</span>
                    <input type="file" accept="image/*" className="hidden" onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      const compressed = await compressImage(file);
                      setAddPetForm(f => ({ ...f, photoUrl: compressed }));
                    }} />
                  </label>
                </div>
              </div>

              {addPetError && (
                <p className="text-red-500 text-xs font-bold bg-red-50 border border-red-100 px-4 py-2 rounded-xl">⚠️ {addPetError}</p>
              )}
            </div>

            {/* Footer */}
            <div className="px-8 py-5 border-t border-purple-50 flex gap-3 bg-purple-50/30">
              <button
                type="button"
                onClick={() => setShowAddPetModal(false)}
                className="flex-1 py-3 bg-white border-2 border-purple-200 text-purple-600 font-bold rounded-2xl hover:bg-purple-50 transition-all"
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={addPetLoading}
                onClick={async () => {
                  // Validate
                  if (!addPetForm.petName.trim()) { setAddPetError("Pet name is required."); return; }
                  if (!addPetForm.breed && !addPetForm.customBreed?.trim()) { setAddPetError("Breed is required."); return; }
                  if (!addPetForm.birthday) { setAddPetError("Birthdate is required."); return; }

                  setAddPetLoading(true);
                  setAddPetError(null);
                  try {
                    const petData = {
                      petName: addPetForm.petName.trim(),
                      petType: addPetForm.petType,
                      breed: addPetForm.isCustomBreed ? addPetForm.customBreed.trim() : addPetForm.breed,
                      gender: addPetForm.gender,
                      birthday: addPetForm.birthday || undefined,
                      photoUrl: addPetForm.photoUrl || undefined,
                    };
                    const res = await axios.post("/api/auth/me/pets", petData, {
                      headers: { Authorization: `Bearer ${user.token}` }
                    });
                    if (res.data.success) {
                      // Refresh user pets
                      const meRes = await axios.get("/api/auth/me", { headers: { Authorization: `Bearer ${user.token}` } });
                      if (meRes.data.success) {
                        const freshUser = { ...user, pets: meRes.data.pets };
                        setUser(freshUser);
                        localStorage.setItem("user", JSON.stringify(freshUser));
                      }
                      setShowAddPetModal(false);
                    }
                  } catch (err) {
                    setAddPetError(err.response?.data?.message || "Failed to add pet. Please try again.");
                  } finally {
                    setAddPetLoading(false);
                  }
                }}
                className={`flex-1 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-black rounded-2xl transition-all shadow-lg ${
                  addPetLoading ? "opacity-50 cursor-wait" : "hover:scale-[1.02] hover:shadow-purple-400/40"
                }`}
              >
                {addPetLoading ? "Saving..." : "Save Pet 🐾"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingForm;
